if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1 ) {
let stepBtnBg = "#ffffff";
!function(e, t) {
  var o = function(x){
        if (x.matches) { // If media query matches
          t(".shop-by-heading-container-mobile:first").click();
          t('.loadMore').showMoreItems({
            nowNum: 1,
            startNum: 4,
            afterNum: 4
          });
        }
      },
      f = function(){
        var x = window.matchMedia("(max-width: 768px)");
		o(x);
      };
    e.init = function() {
        t(".js-shop-by-tab-content-container").find(".js-shop-by-heading-container").on("click", function() {
            t(this).toggleClass("is-active").next().slideToggle(),
            t(this).toggleClass("opened")
        }),
        t(document).ready(function() {
            t(".shop-tab-title:first-child").addClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(1)").addClass("rf-active-slide"),
            t(".js-shop-by-tab-content-container:nth-child(1)").show(),           
            t(".js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(4)").hide()
        }),
        t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(1)").on("click", function() {
            t(this).toggleClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(1)").addClass("rf-active-slide"),
            t(".js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(4)").removeClass("rf-active-slide"),
            t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(1)").show(),
            t(".shop-tab-title:nth-child(3), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(4)").hide(),
            t(".js-shop-by-tab-tiles-container").slick("setPosition"))
        }),
        t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(2)").on("click", function() {
            t(this).toggleClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(1)").removeClass("rf-active-slide"),
            t(".js-shop-by-tab-content-container:nth-child(2)").addClass("rf-active-slide"),
            t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(2)").show(),
            t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(3), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(4)").hide(),
            t(".js-shop-by-tab-tiles-container").slick("setPosition"))
        }),
        t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(3)").on("click", function() {
            t(this).toggleClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(2)").removeClass("rf-active-slide"),
            t(".js-shop-by-tab-content-container:nth-child(3)").addClass("rf-active-slide"),
            t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(3)").show(),
            t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(4)").hide(),
            t(".js-shop-by-tab-tiles-container").slick("setPosition"))
        }),
        t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(4)").on("click", function() {
            t(this).toggleClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(3)").removeClass("rf-active-slide"),
            t(".js-shop-by-tab-content-container:nth-child(4)").addClass("rf-active-slide"),
            t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(4)").show(),
            t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(3)").removeClass("is-active-title"),
            t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(3)").hide(),
            t(".js-shop-by-tab-tiles-container").slick("setPosition"))
        })
    };
  e.init();
  f();
}(window.ShopBySection = window.ShopBySection || {}, jQuery),
function(e, t) {
    var o = {}
      , n = window.innerWidth <= 782
    
      , a = {
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: !0,
        dots: !1,
        infinite: !0,
        responsive: [
           {
             breakpoint: 1024,
             settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: !0,
                dots: !1,
                infinite: !0,
            }
          },
          {
            breakpoint: 782,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: !0,
                dots: !1,
                infinite: !0,
            }
         },
         {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: !0,
                dots: !1,
                infinite: !0,
            }
         }
      ]
    },
        i = {
        slidesToShow: 1,
        arrows: !0,
        dots: !1,
        autoplay: !0,
          adaptiveHeight: !0,
        autoplaySpeed: 8e3,
        pauseOnHover: !1,
        responsive: [{
            breakpoint: 783,
            settings: {
                dots: !1
            }
        }]
    }
          , l = {
        slidesToShow: 1,
        dots: !1,
        arrows: !1,
        adaptiveHeight: !0
    }
      , f = function() {o.homeShopBySlider.slick(a)};
    e.init = function() {
        t(window).on("load resize orientationchange", function() {
            t(".js-promo-tile-grid-container, .js-the-klog-articles-container").each(function() {
                var e = t(this);
                t(window).width() >= 783 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    mobileFirst: !0,
                    arrows: !0,
                    dots: !0
                })
            })
        }),
        t(window).on("load resize orientationchange", function() {
            t(".js-account--nav__control-bar-inner-orders").each(function() {
                var e = t(this);
                t(window).width() >= 992 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
                    infinite: !1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    mobileFirst: !0,
                    arrows: !0,
                    dots: !1
                })
            })
        }),
        t(window).on("load resize orientationchange", function() {
            t(".js-account--nav__control-bar-inner-info").each(function() {
                var e = t(this);
                t(window).width() >= 992 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
                    infinite: !1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    mobileFirst: !0,
                    arrows: !0,
                    dots: !1,
                    initialSlide: 1
                })
            })
        }),
        t(window).on("load resize orientationchange", function() {
            t(".js-account--nav__control-bar-inner-addresses").each(function() {
                var e = t(this);
                t(window).width() >= 992 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
                    infinite: !1,
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    mobileFirst: !0,
                    arrows: !0,
                    dots: !1,
                    initialSlide: 2
                })
            })
        }),
        t(window).on("resize", function(e) {
            window.innerWidth > 782 ? n && (f(),
            n = !1) : n || (n = !0)
        }),
        o.homeHeroSlider = t(".js-homepage-slider-container"),
        o.homeShopBySlider = t(".js-shop-by-tab-tiles-container"),
        o.tenStepLandingPageSlider = t(".slides__container"),
        o.homeShopBySlider.slick(a),
        o.tenStepLandingPageSlider.slick(l),
		o.homeHeroSlider.slick(i)

    };
  e.init();
}(window.Sliders = window.Sliders || {}, jQuery),

// function(e, t) {
//     "use strict";
//     var o = {}
//       , n = {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: !0,
//         arrows: !0,
//         infinite: !1
//     }
//       , i = function() {
//         o.quickshop.find("#quickshop-main-slider").slick(n),
//         o.quickshop.find(".slick-prev").click()
//     }
//       , a = function() {
//         console.log("Quickshop - Product", window.productJson),
//         "Title" !== window.productJson.options[0] && setTimeout(function() {
//             var e;
//             (e = o.quickshop.find(".selector-wrapper")).each(function() {
//                 var o = t(this)
//                   , n = o.find("label")
//                   , i = o.find("select")
//                   , a = n.text().toLowerCase()
//                   , r = o.find("option:selected")
//                   , s = i.find("option")
//                   , l = t('<ul class="dummy-select option-' + a + '"></ul>')
//                   , c = n.length > 0 ? n.text() : r.text()
//                   , d = t('<div class="selection">' + c + "</div>");
//                 setTimeout(function() {
//                     s.each(function(e, o) {
//                         var n, i = t(o);
//                         n = i.hasClass("disabled") ? "disabled" : "",
//                         l.append('<li class="' + n + '" val="' + i.attr("value") + '" data-dummy-index="' + e + '"><span class="' + a + "-" + Shopify.handleize(i.attr("value")) + '"></span>' + i.text() + "</li>")
//                     }),
//                     o.prepend(l),
//                     o.prepend(d),
//                     n.add(i).hide()
//                 }, 0),
//                 setTimeout(function() {
//                     var n = (o = t(".selector-wrapper li:first-child")).attr("val")
//                       , a = o.text();
//                     o.closest(e).find(d).html(c + ": <div class='selection-current'>" + a + "</div>"),
//                     o.addClass("is-active").siblings().removeClass("is-active"),
//                     i.val(n).trigger("change")
//                 }, 0),
//                 e.on("click", "li", function() {
//                     var n = (o = t(this)).attr("val")
//                       , a = o.text();
//                     o.closest(e).find(d).html(c + ": <div class='selection-current'>" + a + "</div>"),
//                     o.addClass("is-active").siblings().removeClass("is-active"),
//                     i.val(n).trigger("change")
//                 })
//             })
//         }, 500)
//     }
//       , r = function() {
//         new Yotpo.API(yotpo).refreshWidgets()
//     }
//       , s = function(e) {
//         var n, i, r;
//         o.quickshop.html(e),
//         a(),
//         n = t(".description--see-more"),
//         i = t(".description--text-summary"),
//         r = t(".description--text-full"),
//         n.on("click", function(e) {
//             e.preventDefault(),
//             i.toggleClass("hide"),
//             r.toggleClass("hide"),
//             n.hide()
//         })
//     }
//       , l = function() {
//         o.quickshopTrigger.on("click", function() {
          
//           console.log('event Triggered');
//             var o;
//             o = t(this).attr("data-product-handle");
//             t.getJSON('/products/'+o+'.js', function(product) {
//   			  window.productJson = JSON.stringify(product);
//               t.get("/products/" + o + "?view=quickshop").then(s).then(r).then(window.Overlay.show).then(OptionSelection.init).done(e.show);
// 			});
//         })
//     };
//     e.show = function() {
//         o.quickshop.fadeToggle(200)
//     }
//     ,
//     e.hide = function() {
//         o.quickshop.hide()
//     }
//     ,
//     e.init = function() {
//         o.quickshop = t("[data-quickshop]"),
//         o.quickshopTrigger = t("[data-trigger-quickshop]"),
//         l()
//     };
//   e.init();
// }(window.Quickshop = window.Quickshop || {}, jQuery),
function(e, t) {
    var o = {};
    e.show = function() {
        o.mobileFilterToggle.addClass("is-active"),
        o.mobileFilter.addClass("is-active"),
        Scroll.lock(),
        Overlay.show()
    }
    ,
    e.hide = function() {
        o.mobileFilterToggle.removeClass("is-active"),
        o.mobileFilter.removeClass("is-active"),
        Scroll.unlock(),
        Overlay.hide()
    }
    ;
    var n = function() {
        return t("#slider-range").data("highest-price") + 10
    }
      , i = function() {
        var e = 0
          , n = t(".mobile-filter-footer").innerHeight()
          , i = t(".mobile-filter-header").innerHeight()
          , a = t(window).innerHeight() - e;
        window.innerWidth < 1024 ? (t(".filter__wrapper").css({
            top: e
        }).css("height", a),
        t(".mobile-filter-content").css("height", a - n - i),
        o.mobileFilterToggle.show()) : (t(".filter__wrapper").removeClass("mobile-view"),
        t("[toggle-mobile-filter]").hide(),
        window.Overlay.hide(),
        o.mobileFilterToggle.removeClass("is-active"),
        o.mobileFilter.removeClass("is-active"))
    }
      , a = function() {
        t("body,html").animate({
            scrollTop: t(".collection-grid").offset().top - 140
        }, 800)
      }, update_counter = function(){
          setTimeout(function(){
            let c = t(".products .product-grid-item:visible").length;
	        t(".matching-items-text span").html(c);
    	    console.log('updated items count');
          },1000);
      }
      , r = function() {
        t(".product-badge-product-info").each(function() {
            var e = t(this);
            e.children().hasClass("best-seller") && e.children().hasClass("new") && e.find(".badge-item.new").hide()
        }),
        t('.filter-item:contains("Dryness / Hydration")').remove(),
        t("[data-trigger]").on("click", function(e) {
            t(e.currentTarget).siblings("[data-target]").slideToggle().css("overflow", "hidden"),
            t(e.currentTarget).find(".down-arrow").toggleClass("open")
        }),
        t(".filter-item").on("click", function(e) {
            t(".product-grid-item--metafield-container").hide();
            var o = t(e.currentTarget)
              , n = o.text()
              , i = o.data("value")
              , a = '<span class="filtered-item" data-value="' + i + '">' + n + ' <span class="remov-icon"><?xml version="1.0" encoding="UTF-8"?><svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> \x3c!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch --\x3e <title>$ICON / close</title> <desc>Created with Sketch.</desc> <defs></defs> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.55"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-683.000000, -288.000000)" fill="#000000"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="active-filters" transform="translate(80.000000, 0.000000)"> <g id="$ICON-/-close" transform="translate(280.000000, 15.000000)"> <path d="M9.00684932,8.11187215 C8.94292237,8.04794521 8.94292237,7.95205479 9.00684932,7.88812785 L11.4041096,5.49086758 C11.4680365,5.42694064 11.5,5.33105023 11.5,5.26712329 C11.5,5.20319635 11.4680365,5.10730594 11.4041096,5.043379 L10.956621,4.59589041 C10.8926941,4.53196347 10.7968037,4.5 10.7328767,4.5 C10.6369863,4.5 10.5730594,4.53196347 10.5091324,4.59589041 L8.11187215,6.99315068 C8.04794521,7.05707763 7.95205479,7.05707763 7.88812785,6.99315068 L5.49086758,4.59589041 C5.42694064,4.53196347 5.33105023,4.5 5.26712329,4.5 C5.20319635,4.5 5.10730594,4.53196347 5.043379,4.59589041 L4.59589041,5.043379 C4.53196347,5.10730594 4.5,5.20319635 4.5,5.26712329 C4.5,5.33105023 4.53196347,5.42694064 4.59589041,5.49086758 L6.99315068,7.88812785 C7.05707763,7.95205479 7.05707763,8.04794521 6.99315068,8.11187215 L4.59589041,10.5091324 C4.53196347,10.5730594 4.5,10.6689498 4.5,10.7328767 C4.5,10.7968037 4.53196347,10.8926941 4.59589041,10.956621 L5.043379,11.4041096 C5.10730594,11.4680365 5.20319635,11.5 5.26712329,11.5 C5.33105023,11.5 5.42694064,11.4680365 5.49086758,11.4041096 L7.88812785,9.00684932 C7.95205479,8.94292237 8.04794521,8.94292237 8.11187215,9.00684932 L10.5091324,11.4041096 C10.5730594,11.4680365 10.6689498,11.5 10.7328767,11.5 C10.7968037,11.5 10.8926941,11.4680365 10.956621,11.4041096 L11.4041096,10.956621 C11.4680365,10.8926941 11.5,10.7968037 11.5,10.7328767 C11.5,10.6689498 11.4680365,10.5730594 11.4041096,10.5091324 L9.00684932,8.11187215 Z" id="icon-close"></path> </g> </g> </g> </g> </g></svg></span></span>';
            o.hasClass("mixitup-control-active") ? t("[filtered-items]").find('[data-value="' + i + '"]').remove() : t("[filtered-items]").append(a),
            0 == t(".filtered-items").children().length ? t(".clear-filters").addClass("hide-clear-filter-btn") : t(".clear-filters").removeClass("hide-clear-filter-btn"),
            t(".mixitup-control-active").length > 0 ? t(".clear-filters").show() : t(".clear-filters").hide();
            update_counter();
        }),
        t(".filtered-items").on("click", ".filtered-item", function(e) {
            var o = t(e.currentTarget).data("value");
            t(".filter-item.mixitup-control-active").map(function(e, n) {
                t(n).data("value") === o && t(n).trigger("click")
            }),
            t(e.currentTarget).remove()
            update_counter()
        }),
        t("[js-sort-by]").on("change", function() {
            var e = t("[js-sort-by]").val();
            window.$mixer.sort(e).then(function(e) {
                return console.log(e.activeSort.sortString)
            })
            update_counter()
        }),
        t("[clear-filters]").on("click", function(e) {
            t("[data-filter-group]").map(function(e, o) {
                var n = t(o).data("filter-group");
                window.$mixer.setFilterGroupSelectors(n, [])
            }),
            window.$mixer.parseFilterGroups(),
            t(".clear-filters").hide(),
            t(".filter-item").removeClass("mixitup-control-active"),
            t(".filtered-item").remove(),
            t(".product-grid-item--metafield-container").show()
            update_counter()
        }),
        t("#slider-range").slider({
            range: !0,
            min: 0,
            max: n(),
            step: 5,
            values: [0, n()],
            slide: function(e, o) {
                var n = o.values[0]
                  , i = o.values[1];
                t("[min-text]").text("$ " + n),
                t("[max-text]").text("$ " + i)
            },
            change: function(e, t) {
                var o = function(e, t) {
                    return Array.from({
                        length: t + 1 - e
                    }, function(t, o) {
                        return o + e
                    }).map(function(e) {
                        return ".price--" + e
                    })
                }(t.values[0], t.values[1]);
                window.$mixer.setFilterGroupSelectors("price", o),
                window.$mixer.parseFilterGroups()
                update_counter()
            }
        }),
        t(".sort-item").on("click", function(e) {
            var o = t(e.currentTarget).text();
            t(".selected-sort-by").text(o)
        }),
        o.mobileFilterToggle.on("click", function(o) {
            t(o.currentTarget).hasClass("is-active") ? e.hide() : e.show()
        }),
        t(window).on("resize", function() {
            i()
        })
    };
    e.init = function() {
        var e, n;
        o.mobileFilterToggle = t("[toggle-mobile-filter]"),
        o.mobileFilter = t("[data-mobile-filter]"),
        r(),
        e = t("#slider-range").slider("values", 0),
        n = t("#slider-range").slider("values", 1),
        t("[min-text]").text("$" + e),
        t("[max-text]").text("$" + n),
        function() {
            window.$mixer = mixitup(".mixitup-container", {
                multifilter: {
                    enable: !0
                },
                callbacks: {
                    onMixStart: function(e) {
                        t(".js-no-collection-results").fadeOut(),
                        a()
                    },
                    onMixEnd: function(e) {
                        t("[matching-items]").text(e.totalMatching),
                        e.totalMatching < 1 ? t("[data-no-results]").fadeIn() : t("[data-no-results]").fadeOut()
                    }
                },
                controls: {
                    toggleLogic: "or"
                },
                pagination: {
                    limit: 40,
                    hidePageListIfSinglePage: !0
                },
                templates: {
                    pagerPrev: '<button type="button" class="${classNames}" data-page="prev"><?xml version="1.0" encoding="UTF-8"?><svg width="5px" height="8px" viewBox="0 0 5 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-1057.000000, -288.000000)" fill="#8C8C8C"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="pagination" transform="translate(738.000000, 5.000000)"> <g id="$ICON-/-arrow-left" transform="translate(2.500000, 18.000000) rotate(-270.000000) translate(-2.500000, -18.000000) translate(-1.500000, 15.500000)"> <path d="M4.1429849,4.70326016 L7.70187818,1.14436688 C7.78567264,1.06057242 7.78567264,0.926185065 7.70187818,0.842390599 C7.61808371,0.758596132 7.48369636,0.758596132 7.39990189,0.842390599 L3.99278727,4.24950522 L0.585672643,0.842390599 C0.501878176,0.758596132 0.367490824,0.758596132 0.283696358,0.842390599 C0.242589639,0.883497318 0.220455251,0.938833286 0.220455251,0.992588227 C0.220455251,1.04634317 0.241008611,1.10167914 0.283696358,1.14278586 L3.84258964,4.70167914 C3.92480308,4.7854736 4.06077146,4.7854736 4.1429849,4.70326016 Z" id="icon-arrow-down"></path> </g> </g> </g> </g> </g></svg></button>',
                    pagerNext: '<button type="button" class="${classNames}" data-page="next"><?xml version="1.0" encoding="UTF-8"?><svg width="5px" height="8px" viewBox="0 0 5 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-1108.000000, -288.000000)" fill="#8C8C8C"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="pagination" transform="translate(738.000000, 5.000000)"> <g id="$ICON-/-arrow-right" transform="translate(53.500000, 18.000000) rotate(-90.000000) translate(-53.500000, -18.000000) translate(49.500000, 15.500000)"> <path d="M4.1429849,4.70326016 L7.70187818,1.14436688 C7.78567264,1.06057242 7.78567264,0.926185065 7.70187818,0.842390599 C7.61808371,0.758596132 7.48369636,0.758596132 7.39990189,0.842390599 L3.99278727,4.24950522 L0.585672643,0.842390599 C0.501878176,0.758596132 0.367490824,0.758596132 0.283696358,0.842390599 C0.242589639,0.883497318 0.220455251,0.938833286 0.220455251,0.992588227 C0.220455251,1.04634317 0.241008611,1.10167914 0.283696358,1.14278586 L3.84258964,4.70167914 C3.92480308,4.7854736 4.06077146,4.7854736 4.1429849,4.70326016 Z" id="icon-arrow-down"></path> </g> </g> </g> </g> </g></svg></button>'
                }
            });
            var e = window.$mixer.getState().totalMatching;
            t("[matching-items]").text(e)
        }(),
        i()
    };
  if(document.querySelector('body').classList.contains('template-collection')){
  e.init();
  }
}(window.Filter = window.Filter || {}, jQuery);

!function(e, t) {
    "use strict";
    var o = {}
      , n = function() {
        o.toggle.on("click", function(e) {
            var n, i, a;
            window.innerWidth <= 991 && (e.preventDefault(),
            n = t(this),
            i = n.next(o.content),
            a = n.find(o.icon),
            i.slideToggle(),
            a.length && a.toggleClass("is-active"))
        })
    };
    e.init = function() {
        o.toggle = t("[data-accordion-toggle]"),
        o.content = t("[data-accordion-content]"),
        o.icon = t("[data-accordion-icon]"),
        o.footer = t("#site-footer"),
        n()
    }
}(window.Accordion = window.Accordion || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {}
      , n = {}
      , i = function(e) {
        var o = t(e.currentTarget)
          , i = o.find('[name="customer[first_name]"]').val()
          , a = o.find('[name="customer[last_name]"]').val()
          , r = o.find('[name="customer[email]"]').val();
        if (n.datePicker && n.datePicker.dateSelected) {
            var s = n.datePicker.dateSelected
              , l = s.getDate()
              , c = s.getFullYear() + "-" + (s.getMonth() + 1) + "-" + l;
            t("#customer_dob_note").val(c)
        }
        Sailthru.integration("userSignUp", {
            email: r,
            vars: {
                first_name: i,
                last_name: a
            }
        })
    }
      , a = function() {
        if (!n.datePicker)
            return null;
        var e = n.datePicker.getFormattedValue().replace(/\//g, "-");
        return e || null
    };
    e.init = function() {
        o.register = t(".js-account-register"),
        o.info = t(".js-account-info"),
        o.inputs = t(".js-account-register input"),
        o.register.on("submit", i),
        t(".js-account-register").attr("autocomplete", "off"),
        o.info.on("click", ".js-account-info-submit", function(e) {
            e.preventDefault();
            var o = a()
              , n = t("[data-customer]").attr("data-customer");
            t(".js-account-info-submit").prop("disabled", !0),
            t.post(window.DOB_API_BASE + "/v1/saveUserDob", {
                customer_id: n,
                birth_date: o
            }).then(function(e) {
                t(".js-account-info-submit").prop("disabled", !1),
                t("#dob").removeClass("editable"),
                t(".js-account-info-submit").hide("style"),
                t(".account--info-birthday-link").removeAttr()
            })
        }),
        function() {
            if (!t("#dob").length)
                return null;
            "" == t("#dob").val().trim() && (t("#dob").val("Loading..."),
            t.get(window.DOB_API_BASE + "/v1/getUserDob?email=" + t("#dob").attr("data-customer-email")).done(function(e) {
                t("#dob").val(e.birth_date)
            }).fail(function() {
                t("#dob").val(""),
                t("#dob").addClass("editable"),
                t(".js-account-info-submit").removeAttr("style"),
                t(".account--info-birthday-link").hide()
            }))
        }(),
        function() {
            if (!window.Cleave || !t("#dob").length)
                return null;
            n.datePicker = new Cleave("#dob",{
                date: !0,
                delimiter: "/",
                datePattern: ["m", "d", "Y"]
            }),
            t("#dob").on("change", function() {
                t("#customer_dob_note").val(a())
            })
        }()
    }
}(window.Account = window.Account || {}, jQuery),
// function(e, t) {
//     CartJS.cart;
//     e.init = function() {
//         t(document).on("click", "[data-add-to-cart]", function(e) {
//             e.preventDefault();
//             var o = t(e.currentTarget)
//               , n = o.attr("data-variant-id") || !1
//               , i = o.closest("form").find("[qty-input]").val() || 1;
//             n && CartJS.addItem(n, i, {}, {
//                 success: function(e, t, o) {
//                     InlineCart.update(InlineCart.show)
//                 },
//                 error: function(e, t, o) {
//                     alert("Error: " + e.responseJSON.description)
//                 }
//             })
//         }),
//         t(document).on("click", "[qty-control]", function(e) {
//             var o = t(e.currentTarget)
//               , n = o.closest("form").find("[qty-input]")
//               , i = parseInt(n.val());
//             if (o.hasClass("qty__control--plus")) {
//                 var a = i + 1;
//                 n.val(a)
//             } else
//                 i > 1 && (a = i - 1,
//                 n.val(a))
//         })
//     }
// }(window.AddToCart = window.AddToCart || {}, jQuery),
// function(e, t) {
//     var o = {}
//       , n = CartJS.cart;
//     e.update = function(e) {
//         t.get("/cart?view=alt").then(function(t) {
//             o.cart.html(t),
//             "function" == typeof e && e()
//         })
//     }
//     ,
//     e.itemCountTotal = function() {
//         o.cartItemCount.text(n.item_count)
//     }
//     ,
//     e.updateCartTotal = function() {
//         formattedCartTotal = (n.total_price / 100).toFixed(2),
//         o.cartTotal.text("$" + formattedCartTotal)
//     }
//     ,
//     e.removeItem = function(t) {
//         CartJS.updateItemById(t, 0, null, {
//             success: function(t, o, n) {
//                 e.update()
//             },
//             error: function(e, t, o) {
//                 window.alert("Sorry, we're unable to do that.\n" + JSON.parse(e.responseText).description)
//             }
//         })
//     }
//     ;
//     e.init = function() {
//         o.cart = t("[data-cart]"),
//         o.lineItemEntryPoint = t("[data-cart-contents]"),
//         o.cartItemCount = t("[data-cart-item-count]"),
//         o.cartTotal = t("[data-cart-total]"),
//         t(document).on("cart.requestComplete", function(t, o) {
//             e.update(),
//             e.itemCountTotal(),
//             e.updateCartTotal()
//         }),
//         t(document).on("focusin", "[data-line-item-quantity]", function() {
//             t(void 0).data("val", t(void 0).val())
//         }),
//         t(document).on("change", "[data-line-item-quantity]", function() {
//             var e = t(void 0).val()
//               , o = t(void 0).closest(".line-item").attr("data-line-number");
//             CartJS.updateItem(o, e, {
//                 success: function(e, t, o) {}
//             })
//         }),
//         e.update()
//     }
// }(window.CartPage = window.CartPage || {}, jQuery),
function(e, t) {
    "use strict";
    e.init = function() {
        t(".js-afterpay-footer-link").click(function() {
            t("html,body").stop().animate({
                scrollTop: t(".the-faqs .drawer:nth-child(3)").offset().top + -100
            }, "linear"),
            t(".the-faqs .drawer:nth-child(3)").addClass("open"),
            t(".the-faqs .drawer:nth-child(3)").attr("id", "afterpay-section")
        }),
        location.hash && (t(location.hash),
        t(".the-faqs .drawer:nth-child(3)").addClass("open")),
        t(window).load(function() {
            location.hash && t("html,body").animate({
                scrollTop: t(".the-faqs .drawer:nth-child(3)").offset().top + -100
            }, "linear")
        }),
        t(".the-faqs .drawer:nth-child(3)").attr("id", "afterpay-section")
    }
}(window.FAQs = window.FAQs || {}, jQuery),
// function(e, t) {
//     var o = {};
//     e.show = function() {
//         o.mobileFilterToggle.addClass("is-active"),
//         o.mobileFilter.addClass("is-active"),
//         Scroll.lock(),
//         Overlay.show()
//     }
//     ,
//     e.hide = function() {
//         o.mobileFilterToggle.removeClass("is-active"),
//         o.mobileFilter.removeClass("is-active"),
//         Scroll.unlock(),
//         Overlay.hide()
//     }
//     ;
//     var n = function() {
//         return t("#slider-range").data("highest-price") + 10
//     }
//       , i = function() {
//         var e = t(".container-fluid").innerHeight()
//           , n = t(".mobile-filter-footer").innerHeight()
//           , i = t(".mobile-filter-header").innerHeight()
//           , a = t(window).innerHeight() - e;
//         window.innerWidth < 1024 ? (t(".filter__wrapper").css({
//             top: e
//         }).css("height", a),
//         t(".mobile-filter-content").css("height", a - n - i),
//         o.mobileFilterToggle.show()) : (t(".filter__wrapper").removeClass("mobile-view"),
//         t("[toggle-mobile-filter]").hide(),
//         Overlay.hide(),
//         o.mobileFilterToggle.removeClass("is-active"),
//         o.mobileFilter.removeClass("is-active"))
//     }
//       , a = function() {
//         t("body,html").animate({
//             scrollTop: t(".collection-grid").offset().top - 140
//         }, 800)
//     }
//       , r = function() {
//         t(".product-badge-product-info").each(function() {
//             var e = t(this);
//             e.children().hasClass("best-seller") && e.children().hasClass("new") && e.find(".badge-item.new").hide()
//         }),
//         t('.filter-item:contains("Dryness / Hydration")').remove(),
//         t("[data-trigger]").on("click", function(e) {
//             t(e.currentTarget).siblings("[data-target]").slideToggle().css("overflow", "auto"),
//             t(e.currentTarget).find(".down-arrow").toggleClass("open")
//         }),
//         t(".filter-item").on("click", function(e) {
//             t(".product-grid-item--metafield-container").hide();
//             var o = t(e.currentTarget)
//               , n = o.text()
//               , i = o.data("value")
//               , a = '<span class="filtered-item" data-value="' + i + '">' + n + ' <span class="remov-icon"><?xml version="1.0" encoding="UTF-8"?><svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> \x3c!-- Generator: Sketch 51.3 (57544) - http://www.bohemiancoding.com/sketch --\x3e <title>$ICON / close</title> <desc>Created with Sketch.</desc> <defs></defs> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.55"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-683.000000, -288.000000)" fill="#000000"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="active-filters" transform="translate(80.000000, 0.000000)"> <g id="$ICON-/-close" transform="translate(280.000000, 15.000000)"> <path d="M9.00684932,8.11187215 C8.94292237,8.04794521 8.94292237,7.95205479 9.00684932,7.88812785 L11.4041096,5.49086758 C11.4680365,5.42694064 11.5,5.33105023 11.5,5.26712329 C11.5,5.20319635 11.4680365,5.10730594 11.4041096,5.043379 L10.956621,4.59589041 C10.8926941,4.53196347 10.7968037,4.5 10.7328767,4.5 C10.6369863,4.5 10.5730594,4.53196347 10.5091324,4.59589041 L8.11187215,6.99315068 C8.04794521,7.05707763 7.95205479,7.05707763 7.88812785,6.99315068 L5.49086758,4.59589041 C5.42694064,4.53196347 5.33105023,4.5 5.26712329,4.5 C5.20319635,4.5 5.10730594,4.53196347 5.043379,4.59589041 L4.59589041,5.043379 C4.53196347,5.10730594 4.5,5.20319635 4.5,5.26712329 C4.5,5.33105023 4.53196347,5.42694064 4.59589041,5.49086758 L6.99315068,7.88812785 C7.05707763,7.95205479 7.05707763,8.04794521 6.99315068,8.11187215 L4.59589041,10.5091324 C4.53196347,10.5730594 4.5,10.6689498 4.5,10.7328767 C4.5,10.7968037 4.53196347,10.8926941 4.59589041,10.956621 L5.043379,11.4041096 C5.10730594,11.4680365 5.20319635,11.5 5.26712329,11.5 C5.33105023,11.5 5.42694064,11.4680365 5.49086758,11.4041096 L7.88812785,9.00684932 C7.95205479,8.94292237 8.04794521,8.94292237 8.11187215,9.00684932 L10.5091324,11.4041096 C10.5730594,11.4680365 10.6689498,11.5 10.7328767,11.5 C10.7968037,11.5 10.8926941,11.4680365 10.956621,11.4041096 L11.4041096,10.956621 C11.4680365,10.8926941 11.5,10.7968037 11.5,10.7328767 C11.5,10.6689498 11.4680365,10.5730594 11.4041096,10.5091324 L9.00684932,8.11187215 Z" id="icon-close"></path> </g> </g> </g> </g> </g></svg></span></span>';
//             o.hasClass("mixitup-control-active") ? t("[filtered-items]").find('[data-value="' + i + '"]').remove() : t("[filtered-items]").append(a),
//             0 == t(".filtered-items").children().length ? t(".clear-filters").addClass("hide-clear-filter-btn") : t(".clear-filters").removeClass("hide-clear-filter-btn"),
//             t(".mixitup-control-active").length > 0 ? t(".clear-filters").show() : t(".clear-filters").hide()
//         }),
//         t(".filtered-items").on("click", ".filtered-item", function(e) {
//             var o = t(e.currentTarget).data("value");
//             t(".filter-item.mixitup-control-active").map(function(e, n) {
//                 t(n).data("value") === o && t(n).trigger("click")
//             }),
//             t(e.currentTarget).remove()
//         }),
//         t("[js-sort-by]").on("change", function() {
//             var e = t("[js-sort-by]").val();
//             window.$mixer.sort(e).then(function(e) {
//                 return console.log(e.activeSort.sortString)
//             })
//         }),
//         t("[clear-filters]").on("click", function(e) {
//             t("[data-filter-group]").map(function(e, o) {
//                 var n = t(o).data("filter-group");
//                 window.$mixer.setFilterGroupSelectors(n, [])
//             }),
//             window.$mixer.parseFilterGroups(),
//             t(".clear-filters").hide(),
//             t(".filter-item").removeClass("mixitup-control-active"),
//             t(".filtered-item").remove(),
//             t(".product-grid-item--metafield-container").show()
//         }),
//         t("#slider-range").slider({
//             range: !0,
//             min: 0,
//             max: n(),
//             step: 5,
//             values: [0, n()],
//             slide: function(e, o) {
//                 var n = o.values[0]
//                   , i = o.values[1];
//                 t("[min-text]").text("$ " + n),
//                 t("[max-text]").text("$ " + i)
//             },
//             change: function(e, t) {
//                 var o = function(e, t) {
//                     return Array.from({
//                         length: t + 1 - e
//                     }, function(t, o) {
//                         return o + e
//                     }).map(function(e) {
//                         return ".price--" + e
//                     })
//                 }(t.values[0], t.values[1]);
//                 window.$mixer.setFilterGroupSelectors("price", o),
//                 window.$mixer.parseFilterGroups()
//             }
//         }),
//         t(".sort-item").on("click", function(e) {
//             var o = t(e.currentTarget).text();
//             t(".selected-sort-by").text(o)
//         }),
//         o.mobileFilterToggle.on("click", function(o) {
//             t(o.currentTarget).hasClass("is-active") ? e.hide() : e.show()
//         }),
//         t(window).on("resize", function() {
//             i()
//         })
//     };
//     e.init = function() {
//         var e, n;
//         o.mobileFilterToggle = t("[toggle-mobile-filter]"),
//         o.mobileFilter = t("[data-mobile-filter]"),
//         r(),
//         e = t("#slider-range").slider("values", 0),
//         n = t("#slider-range").slider("values", 1),
//         t("[min-text]").text("$" + e),
//         t("[max-text]").text("$" + n),
//         function() {
//             window.$mixer = mixitup(".mixitup-container", {
//                 multifilter: {
//                     enable: !0
//                 },
//                 callbacks: {
//                     onMixStart: function(e) {
//                         t(".js-no-collection-results").fadeOut(),
//                         a()
//                     },
//                     onMixEnd: function(e) {
//                         t("[matching-items]").text(e.totalMatching),
//                         e.totalMatching < 1 ? t("[data-no-results]").fadeIn() : t("[data-no-results]").fadeOut()
//                     }
//                 },
//                 controls: {
//                     toggleLogic: "or"
//                 },
//                 pagination: {
//                     limit: 40,
//                     hidePageListIfSinglePage: !0
//                 },
//                 templates: {
//                     pagerPrev: '<button type="button" class="${classNames}" data-page="prev"><?xml version="1.0" encoding="UTF-8"?><svg width="5px" height="8px" viewBox="0 0 5 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-1057.000000, -288.000000)" fill="#8C8C8C"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="pagination" transform="translate(738.000000, 5.000000)"> <g id="$ICON-/-arrow-left" transform="translate(2.500000, 18.000000) rotate(-270.000000) translate(-2.500000, -18.000000) translate(-1.500000, 15.500000)"> <path d="M4.1429849,4.70326016 L7.70187818,1.14436688 C7.78567264,1.06057242 7.78567264,0.926185065 7.70187818,0.842390599 C7.61808371,0.758596132 7.48369636,0.758596132 7.39990189,0.842390599 L3.99278727,4.24950522 L0.585672643,0.842390599 C0.501878176,0.758596132 0.367490824,0.758596132 0.283696358,0.842390599 C0.242589639,0.883497318 0.220455251,0.938833286 0.220455251,0.992588227 C0.220455251,1.04634317 0.241008611,1.10167914 0.283696358,1.14278586 L3.84258964,4.70167914 C3.92480308,4.7854736 4.06077146,4.7854736 4.1429849,4.70326016 Z" id="icon-arrow-down"></path> </g> </g> </g> </g> </g></svg></button>',
//                     pagerNext: '<button type="button" class="${classNames}" data-page="next"><?xml version="1.0" encoding="UTF-8"?><svg width="5px" height="8px" viewBox="0 0 5 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"> <g id="Collections" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="D-Collections-v1a-/-active-filters" transform="translate(-1108.000000, -288.000000)" fill="#8C8C8C"> <g id="utility-bar" transform="translate(319.000000, 269.000000)"> <g id="pagination" transform="translate(738.000000, 5.000000)"> <g id="$ICON-/-arrow-right" transform="translate(53.500000, 18.000000) rotate(-90.000000) translate(-53.500000, -18.000000) translate(49.500000, 15.500000)"> <path d="M4.1429849,4.70326016 L7.70187818,1.14436688 C7.78567264,1.06057242 7.78567264,0.926185065 7.70187818,0.842390599 C7.61808371,0.758596132 7.48369636,0.758596132 7.39990189,0.842390599 L3.99278727,4.24950522 L0.585672643,0.842390599 C0.501878176,0.758596132 0.367490824,0.758596132 0.283696358,0.842390599 C0.242589639,0.883497318 0.220455251,0.938833286 0.220455251,0.992588227 C0.220455251,1.04634317 0.241008611,1.10167914 0.283696358,1.14278586 L3.84258964,4.70167914 C3.92480308,4.7854736 4.06077146,4.7854736 4.1429849,4.70326016 Z" id="icon-arrow-down"></path> </g> </g> </g> </g> </g></svg></button>'
//                 }
//             });
//             var e = window.$mixer.getState().totalMatching;
//             t("[matching-items]").text(e)
//         }(),
//         i()
//     };
//   e.init();
// }(window.Filter = window.Filter || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {}
      , n = function() {
        o.newsletterForm.on("click", function(e) {
            var n;
            o.placeholder.hasClass("active") || (n = e.target,
            (t(n).hasClass("email") || t(n).hasClass("placeholder")) && (o.placeholder.addClass("active"),
            o.emailInput.focus()))
        }),
        o.body.on("click", function(e) {
            var n;
            o.placeholder.hasClass("active") && (n = e.target,
            t(n).hasClass("email") || t(n).hasClass("placeholder") || t(n).hasClass("footer-newsletter__submit") || 0 != document.querySelector("#site-footer input[type=email]").value.length || o.placeholder.removeClass("active"))
        })
    };
    e.init = function() {
        o.newsletterForm = t(".footer-newsletter__form"),
        o.emailInput = t(".footer-newsletter__group input[type=email]"),
        o.newsletterFormGroup = t(".footer-newsletter__group"),
        o.placeholder = t(".footer-newsletter__placeholder"),
        o.body = t("body"),
        n()
    };
  e.init();
}(window.Footer = window.Footer || {}, jQuery),
// function(e, t) {
//     CartJS.cart;
//     var o = {}
//       , n = {};
//     !1 === o.freeGiftFromProductEnabled && !1 === o.freeGiftFromPrice.enable && !1 === o.freeGiftFromCount.enable && !1 === o.freeGiftFromType.enable && !1 === o.freeGiftFromCollection.enable && !1 === o.freeGiftFromVendor.enable && !1 === o.freeSampleFromPrice.enable && !1 === o.freeSampleFromPrice2.enable && !1 === o.freeSampling.enable && CartJS.cart.items.forEach(function(e) {
//         "Free Gift" === e.product_type && CartJS.removeItemById(e.id)
//     });
//     var i = function() {
//         !1 === o.freeGiftFromProductEnabled && !1 === o.freeGiftFromPrice.enable && !1 === o.freeGiftFromCount.enable && !1 === o.freeGiftFromType.enable && !1 === o.freeGiftFromVendor.enable && !1 === o.freeSampleFromPrice.enable && !1 === o.freeSampleFromPrice2.enable && !1 === o.freeSampling.enable && CartJS.cart.items.forEach(function(e) {
//             "Free Gift" !== e.product_type && "Gift With Purchase" !== e.product_type && "Sample" !== e.product_type || CartJS.removeItemById(e.id)
//         })
//     }
//       , a = function() {
//         o.freeGiftFromProduct.enable && console.log("🎁Active Promo: GWP - Product"),
//         o.freeGiftFromPrice.enable && console.log("🎁Active Promo: GWP - Cart Total "),
//         o.freeGiftFromCount.enable && console.log("🎁Active Promo: GWP - Cart Count"),
//         o.freeGiftFromType.enable && console.log("🎁Active Promo: GWP - Product Type"),
//         o.freeGiftFromCollection.enable && console.log("🎁Active Promo: GWP - From Collection"),
//         o.freeGiftFromVendor.enable && console.log("🎁Active Promo: GWP - Product Vendor"),
//         t(document).on("cart.requestComplete", function(e, n) {
//             o.freeGiftFromProduct.enable ? function(e, o) {
//                 var n = e.trigger
//                   , i = e.giftId
//                   , a = e.giftHandle
//                   , r = !1
//                   , s = !1
//                   , l = e.startDate;
//                 console.log("Start date: " + l);
//                 var c = e.endDate;
//                 console.log("End date: " + c);
//                 var d = new Date
//                   , u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
//                 console.log("Today's date: " + u),
//                 u >= l && u < c && t.getJSON("/products/" + a + ".js", function() {}).done(function() {
//                     if (o.items.forEach(function(e) {
//                         n === e.variant_id.toString() && (r = !0),
//                         e.variant_id === parseInt(i, 10) && (s = !0)
//                     }),
//                     r && !s) {
//                         var e = {};
//                         e[i] = 1,
//                         CartJS.updateItemQuantitiesById(e)
//                     } else
//                         !r && s && CartJS.removeItemById(i)
//                 })
//             }(o.freeGiftFromProduct, n) : o.freeGiftFromPrice.enable ? function(e, o) {
//                 var n = e.giftId
//                   , i = e.giftHandle
//                   , a = e.trigger
//                   , r = 100 * parseInt(a, 10)
//                   , s = !1
//                   , l = !1
//                   , c = !1
//                   , d = void 0
//                   , u = o.total_price
//                   , f = []
//                   , g = e.startDate;
//                 console.log("Start date: " + g);
//                 var p = e.endDate;
//                 console.log("End date: " + p);
//                 var h = new Date
//                   , m = ("0" + (h.getMonth() + 1)).slice(-2) + "/" + ("0" + h.getDate()).slice(-2) + "/" + h.getFullYear() + " " + h.getHours() + ":" + h.getMinutes();
//                 console.log("Today's date: " + m),
//                 o.items.forEach(function(e) {
//                     "Gift Card" === e.product_type && (d = e.line_price,
//                     f.push(d),
//                     c = !0)
//                 }),
//                 c && (u -= f.reduce(function(e, t) {
//                     return e + t
//                 }),
//                 console.log("New Total Price: " + u)),
//                 m >= g && m < p && t.getJSON("/products/" + i + ".js").done(function() {
//                     if (u >= r && (s = !0),
//                     o.items.forEach(function(e) {
//                         e.variant_id === parseInt(n, 10) && (l = !0)
//                     }),
//                     s && !l) {
//                         var e = {};
//                         e[n] = 1,
//                         CartJS.updateItemQuantitiesById(e)
//                     } else
//                         !s && l && CartJS.removeItemById(n)
//                 })
//             }(o.freeGiftFromPrice, n) : o.freeGiftFromCount.enable ? function(e, o) {
//                 var n = e.giftId
//                   , i = e.giftHandle
//                   , a = parseInt(e.trigger)
//                   , r = !1
//                   , s = !1
//                   , l = !1
//                   , c = o.item_count
//                   , d = []
//                   , u = e.startDate
//                   , f = e.endDate
//                   , g = new Date
//                   , p = ("0" + (g.getMonth() + 1)).slice(-2) + "/" + ("0" + g.getDate()).slice(-2) + "/" + g.getFullYear() + " " + g.getHours() + ":" + g.getMinutes();
//                 o.items.forEach(function(e) {
//                     "Gift Card" === e.product_type && (countOfGiftCard = e.quantity,
//                     d.push(countOfGiftCard),
//                     l = !0)
//                 }),
//                 l && (c -= d.reduce(function(e, t) {
//                     return e + t
//                 }),
//                 console.log("New Total Count: " + c)),
//                 p >= u && p < f && (console.log("Today's date: " + p),
//                 o.items.forEach(function(e) {
//                     0 === e.price && c--
//                 }),
//                 t.getJSON("/products/" + i + ".js").done(function() {
//                     if (c >= a && (r = !0),
//                     o.items.forEach(function(e) {
//                         e.variant_id === parseInt(n, 10) && (s = !0)
//                     }),
//                     r && !s) {
//                         var e = {};
//                         e[n] = 1,
//                         CartJS.updateItemQuantitiesById(e, {
//                             is_free_gift: "true"
//                         })
//                     } else
//                         !r && s && (CartJS.removeItemById(n),
//                         CartJS.removeItemById(n, {
//                             success: function(e, o, i) {
//                                 t('[data-variant-id="' + n + '"]').remove()
//                             }
//                         }))
//                 }))
//             }(o.freeGiftFromCount, n) : o.freeGiftFromType.enable ? function(e, o) {
//                 var n = e.giftId
//                   , i = e.giftHandle
//                   , a = e.trigger
//                   , r = !1
//                   , s = !1
//                   , l = e.startDate;
//                 console.log("Start date: " + l);
//                 var c = e.endDate;
//                 console.log("End date: " + c);
//                 var d = new Date
//                   , u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
//                 console.log("Today's date: " + u),
//                 u >= l && u < c && t.getJSON("/products/" + i + ".js").done(function() {
//                     if (o.items.forEach(function(e) {
//                         console.log("tags: " + e.tags),
//                         e.product_type === a && (r = !0),
//                         e.variant_id === parseInt(n, 10) && (s = !0)
//                     }),
//                     r && !s) {
//                         var e = {};
//                         e[n] = 1,
//                         CartJS.updateItemQuantitiesById(e)
//                     } else
//                         !r && s && CartJS.removeItemById(n)
//                 })
//             }(o.freeGiftFromType, n) : o.freeGiftFromCollection.enable ? function(e, o) {
//                 var n = e.giftId
//                   , i = e.giftHandle
//                   , a = e.trigger
//                   , r = !1
//                   , s = !1
//                   , l = e.startDate;
//                 console.log("Start date: " + l);
//                 var c = e.endDate;
//                 console.log("End date: " + c);
//                 var d = new Date
//                   , u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
//                 console.log("Today's date: " + u),
//                 u >= l && u < c && t.getJSON("/products/" + i + ".js").done(function() {
//                     if (o.items.forEach(function(e) {
//                         "Gift Card" !== e.product_type && (console.log("tags: " + e.tags),
//                         -1 !== a.indexOf(e.handle) && (r = !0),
//                         e.variant_id === parseInt(n, 10) && (s = !0))
//                     }),
//                     r && !s) {
//                         var e = {};
//                         e[n] = 1,
//                         CartJS.updateItemQuantitiesById(e)
//                     } else
//                         !r && s && CartJS.removeItemById(n)
//                 })
//             }(o.freeGiftFromCollection, n) : o.freeGiftFromVendor.enable ? function(e, o) {
//                 var n = e.giftId
//                   , i = e.giftHandle
//                   , a = e.trigger
//                   , r = !1
//                   , s = !1
//                   , l = e.startDate;
//                 console.log("Start date: " + l);
//                 var c = e.endDate;
//                 console.log("End date: " + c);
//                 var d = new Date
//                   , u = ("0" + (d.getMonth() + 1)).slice(-2) + "/" + ("0" + d.getDate()).slice(-2) + "/" + d.getFullYear() + " " + d.getHours() + ":" + d.getMinutes();
//                 console.log("Today's date: " + u),
//                 u >= l && u < c && t.getJSON("/products/" + i + ".js").done(function() {
//                     if (o.items.forEach(function(e) {
//                         e.vendor === a && "Gift Card" !== e.product_type && (r = !0),
//                         e.variant_id === parseInt(n, 10) && (s = !0)
//                     }),
//                     r && !s) {
//                         var e = {};
//                         e[n] = 1,
//                         CartJS.updateItemQuantitiesById(e)
//                     } else
//                         !r && s && CartJS.removeItemById(n)
//                 })
//             }(o.freeGiftFromVendor, n) : i()
//         })
//     }
//       , r = function() {
//         o.freeSampleFromPrice.enable && console.log("🎁Active Promo: Free Sample"),
//         t(document).on("cart.requestComplete", function(e, n) {
//             o.freeSampleFromPrice.enable && function(e, o) {
//                 var n = e.giftQuantity
//                   , i = e.giftId
//                   , a = e.giftHandle
//                   , r = e.trigger
//                   , s = 100 * parseInt(r, 10)
//                   , l = !1
//                   , c = !1
//                   , d = !1
//                   , u = void 0
//                   , f = o.total_price
//                   , g = []
//                   , p = e.startDate;
//                 console.log("Start date: " + p);
//                 var h = e.endDate;
//                 console.log("End date: " + h);
//                 var m = new Date
//                   , v = ("0" + (m.getMonth() + 1)).slice(-2) + "/" + ("0" + m.getDate()).slice(-2) + "/" + m.getFullYear() + " " + m.getHours() + ":" + m.getMinutes();
//                 console.log("Today's date: " + v),
//                 o.items.forEach(function(e) {
//                     "Gift Card" === e.product_type && (u = e.line_price,
//                     g.push(u),
//                     d = !0)
//                 }),
//                 d && (f -= g.reduce(function(e, t) {
//                     return e + t
//                 }),
//                 console.log("New Total Price: " + f)),
//                 v >= p && v < h && t.getJSON("/products/" + a + ".js").done(function() {
//                     if (f >= s && (l = !0),
//                     o.items.forEach(function(e) {
//                         e.variant_id === parseInt(i, 10) && (c = !0)
//                     }),
//                     l && !c) {
//                         var e = {};
//                         e[i] = n,
//                         CartJS.updateItemQuantitiesById(e)
//                     } else
//                         !l && c && CartJS.removeItemById(i)
//                 })
//             }(o.freeSampleFromPrice, n)
//         })
//     }
//       , s = function() {
//         o.freeSampleFromPrice2.enable && console.log("🎁Active Promo: Free Sample Promo"),
//         t(document).on("cart.requestComplete", function(e, n) {
//             o.freeSampleFromPrice2.enable && function(e, o) {
//                 var n = e.giftQuantity
//                   , i = e.giftId
//                   , a = e.giftHandle
//                   , r = e.trigger
//                   , s = 100 * parseInt(r, 10)
//                   , l = !1
//                   , c = !1
//                   , d = !1
//                   , u = void 0
//                   , f = o.total_price
//                   , g = []
//                   , p = e.startDate;
//                 console.log("Start date: " + p);
//                 var h = e.endDate;
//                 console.log("End date: " + h);
//                 var m = new Date
//                   , v = ("0" + (m.getMonth() + 1)).slice(-2) + "/" + ("0" + m.getDate()).slice(-2) + "/" + m.getFullYear() + " " + m.getHours() + ":" + m.getMinutes();
//                 console.log("Today's date: " + v),
//                 o.items.forEach(function(e) {
//                     "Gift Card" === e.product_type && (u = e.line_price,
//                     g.push(u),
//                     d = !0)
//                 }),
//                 d && (f -= g.reduce(function(e, t) {
//                     return e + t
//                 }),
//                 console.log("New Total Price: " + f)),
//                 v >= p && v < h && t.getJSON("/products/" + a + ".js").done(function() {
//                     if (f >= s && (l = !0),
//                     o.items.forEach(function(e) {
//                         e.variant_id === parseInt(i, 10) && (c = !0)
//                     }),
//                     l && !c) {
//                         var e = {};
//                         e[i] = n,
//                         CartJS.updateItemQuantitiesById(e)
//                     } else
//                         !l && c && CartJS.removeItemById(i)
//                 })
//             }(o.freeSampleFromPrice2, n)
//         })
//     }
//       , l = function(e, n) {
//         if (o.birthdayGiftFromCode.enable) {
//             console.log("🎁Active Promo: Birthday Gift Code");
//             var i = window.location.href
//               , a = e.trigger1
//               , r = "birthday_gift_code=" + a;
//             i.indexOf(r) > -1 && (sessionStorage.setItem("birthday_gift_code", a),
//             console.log("Birthday Code Saved")),
//             t(document).on("cart.requestComplete", function(e, n) {
//                 !function(e, o) {
//                     var n = e.giftId
//                       , i = e.giftHandle
//                       , a = e.trigger1
//                       , r = e.trigger2
//                       , s = 100 * parseInt(r, 10)
//                       , l = sessionStorage.getItem("birthday_gift_code")
//                       , c = !1
//                       , d = !1
//                       , u = !1
//                       , f = void 0
//                       , g = o.total_price
//                       , p = []
//                       , h = e.startDate
//                       , m = e.endDate
//                       , v = new Date
//                       , _ = ("0" + (v.getMonth() + 1)).slice(-2) + "/" + ("0" + v.getDate()).slice(-2) + "/" + v.getFullYear() + " " + v.getHours() + ":" + v.getMinutes();
//                     o.items.forEach(function(e) {
//                         "Gift Card" === e.product_type && (f = e.line_price,
//                         p.push(f),
//                         u = !0)
//                     }),
//                     u && (g -= p.reduce(function(e, t) {
//                         return e + t
//                     }),
//                     console.log("New Total Price: " + g)),
//                     _ >= h && _ < m && (l === a && g >= s && (c = !0),
//                     t.getJSON("/products/" + i + ".js").done(function() {
//                         if (o.items.forEach(function(e) {
//                             e.variant_id === parseInt(n, 10) && (d = !0)
//                         }),
//                         c && !d) {
//                             var e = {};
//                             e[n] = 1,
//                             CartJS.updateItemQuantitiesById(e)
//                         } else
//                             !c && d && CartJS.removeItemById(n)
//                     }))
//                 }(o.birthdayGiftFromCode, n)
//             })
//         }
//     }
//       , c = function(e, n) {
//         if (o.birthdayGiftFromCodeSecond.enable) {
//             console.log("🎁Active Promo: Birthday Gift Coupon");
//             var i = window.location.href
//               , a = e.trigger1
//               , r = "birthday_gift_coupon=" + a;
//             i.indexOf(r) > -1 && (sessionStorage.setItem("birthday_gift_coupon", a),
//             console.log("Birthday Coupon Saved")),
//             t(document).on("cart.requestComplete", function(e, n) {
//                 !function(e, o) {
//                     var n = e.giftId
//                       , i = e.giftHandle
//                       , a = e.trigger1
//                       , r = e.trigger2
//                       , s = 100 * parseInt(r, 10)
//                       , l = sessionStorage.getItem("birthday_gift_coupon")
//                       , c = !1
//                       , d = !1
//                       , u = !1
//                       , f = void 0
//                       , g = o.total_price
//                       , p = []
//                       , h = e.startDate
//                       , m = e.endDate
//                       , v = new Date
//                       , _ = ("0" + (v.getMonth() + 1)).slice(-2) + "/" + ("0" + v.getDate()).slice(-2) + "/" + v.getFullYear() + " " + v.getHours() + ":" + v.getMinutes();
//                     o.items.forEach(function(e) {
//                         "Gift Card" === e.product_type && (f = e.line_price,
//                         p.push(f),
//                         u = !0)
//                     }),
//                     u && (g -= p.reduce(function(e, t) {
//                         return e + t
//                     }),
//                     console.log("New Total Price: " + g)),
//                     _ >= h && _ < m && (l === a && g >= s && (c = !0),
//                     t.getJSON("/products/" + i + ".js").done(function() {
//                         if (o.items.forEach(function(e) {
//                             e.variant_id === parseInt(n, 10) && (d = !0)
//                         }),
//                         c && !d) {
//                             var e = {};
//                             e[n] = 1,
//                             CartJS.updateItemQuantitiesById(e)
//                         } else
//                             !c && d && CartJS.removeItemById(n)
//                     }))
//                 }(o.birthdayGiftFromCodeSecond, n)
//             })
//         }
//     }
//       , d = function() {
//         o.freeSampling.enable && console.log("🎁Active Promo: Free Sampling Modal"),
//         t(document).on("cart.requestComplete", function(e, n) {
//             o.freeSampling.enable && function(e, o) {
//                 var n = e.giftId1
//                   , i = (e.giftHandle1,
//                 e.giftId2)
//                   , a = (e.giftHandle2,
//                 e.giftId3)
//                   , r = (e.giftHandle3,
//                 e.trigger)
//                   , s = 100 * parseInt(r, 10)
//                   , l = !1
//                   , c = !1
//                   , d = !1
//                   , u = !1
//                   , f = !1
//                   , g = void 0
//                   , p = o.total_price
//                   , h = []
//                   , m = e.startDate;
//                 console.log("Start date: " + m);
//                 var v = e.endDate;
//                 console.log("End date: " + v);
//                 var _ = new Date
//                   , w = ("0" + (_.getMonth() + 1)).slice(-2) + "/" + ("0" + _.getDate()).slice(-2) + "/" + _.getFullYear() + " " + _.getHours() + ":" + _.getMinutes();
//                 console.log("Today's date: " + w),
//                 o.items.forEach(function(e) {
//                     "Gift Card" === e.product_type && (g = e.line_price,
//                     h.push(g),
//                     f = !0)
//                 }),
//                 f && (p -= h.reduce(function(e, t) {
//                     return e + t
//                 }),
//                 console.log("New Total Price: " + p)),
//                 w >= m && w < v && (p >= s && (l = !0),
//                 o.items.forEach(function(e) {
//                     e.variant_id === parseInt(n, 10) && (c = !0,
//                     console.log("userHasSample1 = true")),
//                     e.variant_id === parseInt(i, 10) && (d = !0,
//                     console.log("userHasSample2 = true")),
//                     e.variant_id === parseInt(a, 10) && (u = !0,
//                     console.log("userHasSample3 = true"))
//                 }),
//                 !l || c || d || u || setTimeout(function() {
//                     t("[data-trigger-gwp-modal]").attr("data-trigger-gwp-modal", "true")
//                 }, 1e3)),
//                 !l && c && CartJS.removeItemById(n),
//                 !l && d && CartJS.removeItemById(i),
//                 !l && u && CartJS.removeItemById(a)
//             }(o.freeSampling, n)
//         })
//     };
//     e.init = function() {
//         n.gwpModalTrigger = t("[data-trigger-gwp-modal]"),
//         t(document).on("click", "[data-trigger-gwp-modal]", function(e) {
//             e.preventDefault(),
//             e.stopImmediatePropagation(),
//             !0 === t(e.currentTarget).data("trigger-gwp-modal") ? (t(".inline-cart").hide(),
//             t(".overlay").hide(),
//             t("body").addClass("no-scroll"),
//             t(".gwp-modal").show()) : window.location.href = "/checkout/"
//         }),
//         t(document).on("click", ".gwp-modal-add-to-cart-button", function(e) {
//             e.preventDefault();
//             var o = t(e.currentTarget)
//               , n = o.attr("data-gwp-variant-id")
//               , i = parseInt(o.attr("data-gwp-qty")) || 1;
//             t(".gwp-inner-modal-container").addClass("gwp-samples-container-active"),
//             o.parent().addClass("added-gwp-sample"),
//             void 0 !== n && "" !== n && (o.hasClass("gwp-sample-added") || (o.text("Adding..."),
//             window.CartJS.addItem(n, i, {}, {
//                 success: function() {
//                     o.addClass("gwp-sample-added").text("Added"),
//                     t(".gwp-sample-decline").text("Proceed to Checkout").removeClass("gwp-btn-gray")
//                 },
//                 error: function(e) {
//                     console.log(e)
//                 }
//             })))
//         }),
//         o.freeGiftFromProduct = {
//             enable: JSON.parse("false"),
//             startDate: "",
//             endDate: "",
//             trigger: "",
//             giftHandle: "",
//             giftId: parseInt("")
//         },
//         o.freeGiftFromPrice = {
//             enable: JSON.parse("true"),
//             startDate: "06/05/2021 09:00",
//             endDate: "06/30/2021 23:00",
//             trigger: "55",
//             giftHandle: "benton-aloe-propolis-soothing-gel-travel-size-gift-w-purchase",
//             giftId: parseInt("39364868374597")
//         },
//         o.freeGiftFromCount = {
//             enable: JSON.parse("false"),
//             startDate: "",
//             endDate: "",
//             trigger: "",
//             giftHandle: "",
//             giftId: parseInt("")
//         },
//         o.freeGiftFromType = {
//             enable: JSON.parse("false"),
//             startDate: "",
//             endDate: "",
//             trigger: "",
//             giftHandle: "",
//             giftId: parseInt("")
//         },
//         o.freeGiftFromCollection = {
//             enable: JSON.parse("false"),
//             startDate: "",
//             endDate: "",
//             trigger: window.gwpCollection,
//             giftHandle: "",
//             giftId: parseInt("")
//         },
//         o.freeGiftFromVendor = {
//             enable: JSON.parse("false"),
//             startDate: "04/13/2021 10:00",
//             endDate: "04/20/2021 23:00",
//             trigger: "IT'S SKIN",
//             giftHandle: "its-skin-power10-formula-vc-effector-10ml-gift-w-purchase",
//             giftId: parseInt("39302155108421")
//         },
//         o.freeSampleFromPrice = {
//             enable: JSON.parse("false"),
//             startDate: "12/18/2020 10:30",
//             endDate: "12/31/2020 23:59",
//             trigger: "1",
//             giftHandle: "living-cleansing-balm-deluxe",
//             giftId: parseInt("31928039833669"),
//             giftQuantity: parseInt("1")
//         },
//         o.freeSampleFromPrice2 = {
//             enable: JSON.parse("false"),
//             startDate: "11/28/2019 12:00",
//             endDate: "12/02/2019 23:59",
//             trigger: "1",
//             giftHandle: "danahan-ginseng-seed-secret-essence-sample-1ml",
//             giftId: parseInt("29372487237701"),
//             giftQuantity: parseInt("1")
//         },
//         o.birthdayGiftFromCode = {
//             enable: JSON.parse("false"),
//             startDate: "04/22/2021 10:00",
//             endDate: "06/03/2021 23:59",
//             trigger1: "minitest",
//             trigger2: "1",
//             giftHandle: "then-i-met-you-living-cleansing-balm-deluxe-gift-w-purchase",
//             giftId: parseInt("32003117711429")
//         },
//         o.birthdayGiftFromCodeSecond = {
//             enable: JSON.parse("true"),
//             startDate: "06/01/2021 01:00",
//             endDate: "06/30/2021 23:59",
//             trigger1: "JUN21",
//             trigger2: "1",
//             giftHandle: "bubble-free-ph-balancing-cleanser-gift-w-purchase",
//             giftId: parseInt("31935772229701")
//         },
//         o.freeSampling = {
//             enable: JSON.parse("false"),
//             startDate: "04/26/2021 09:00",
//             endDate: "05/10/2021 10:00",
//             trigger: "65",
//             giftHandle1: "pure-pearlsation-revitalizing-facial-cleansing-foam-30ml-gift-w-purchase",
//             giftId1: parseInt("39316819247173"),
//             giftHandle2: "vinegar-kombucha-essence-20-ml-gift-w-purchase",
//             giftId2: parseInt("39316832911429"),
//             giftHandle3: "snail-bee-high-content-essence-15ml-gift-w-purchase",
//             giftId3: parseInt("39316834910277")
//         },
//         a(),
//         r(),
//         s(),
//         l(o.birthdayGiftFromCode),
//         c(o.birthdayGiftFromCodeSecond),
//         d(),
//         i()
//     }
// }(window.FreeGift = window.FreeGift || {}, jQuery),

function(e, t) {
    "use strict";
    e.debounce = function(e, t, o) {
        var n = void 0;
        return function() {
            var i = this
              , a = arguments
              , r = o && !n;
            clearTimeout(n),
            n = setTimeout(function() {
                n = null,
                o || e.apply(i, a)
            }, t),
            r && e.apply(i, a)
        }
    }
    ,
    e.handlize = function(e) {
        e = e.toLowerCase();
        for (var t = ['"', "'", "\\", "(", ")", "[", "]", "$"], o = 0; o < t.length; ++o)
            e = e.replace(t[o], "");
        return "-" == (e = e.replace(/\W+/g, "-")).charAt(e.length - 1) && (e = e.replace(/-+\z/, "")),
        "-" == e.charAt(0) && (e = e.replace(/\A-+/, "")),
        e
    }
}(window.Helpers = window.Helpers || {}, jQuery),
// function(e, t) {
//     "use strict";
//     var o = {}
//       , n = CartJS.cart;
//     e.update = function(n) {
//         t.get("/cart?view=contents").then(function(t) {
//             o.inlineCart.html(t),
//             e.itemCountTotal(),
//             "function" == typeof n && n()
//         })
//     }
//     ,
//     e.itemCountTotal = function() {
//         CartJS.cart.item_count;
//         o.cartItemCount.text(n.item_count)
//     }
//     ,
//     e.checkForGWP = function() {
//         CartJS.cart.item_count;
//         o.cartItemCount.text(n.item_count)
//     }
//     ,
//     e.show = function() {
//         o.inlineCart.addClass("is-active"),
//         Overlay.show(),
//         Scroll.lock(),
//         Quickshop.hide()
//     }
//     ,
//     e.hide = function() {
//         o.inlineCart.removeClass("is-active"),
//         Overlay.hide(),
//         Scroll.unlock()
//     }
//     ,
//     e.toggle = function() {
//         e.update(),
//         o.inlineCart.hasClass("is-active") ? e.hide() : e.show()
//     }
//     ,
//     e.removeItem = function(t) {
//         CartJS.updateItemById(t, 0, null, {
//             success: function(t, o, n) {
//                 e.update()
//             },
//             error: function(e, t, o) {
//                 window.alert("Sorry, we're unable to do that.\n" + JSON.parse(e.responseText).description)
//             }
//         })
//     }
//     ;
//     e.init = function() {
//         o.inlineCart = t("[data-inline-cart]"),
//         o.lineItemEntryPoint = t("[data-cart-contents]"),
//         o.inlineCartToggle = t("[data-inline-cart-toggle]"),
//         o.overlay = t("[data-overlay]"),
//         o.cartItemCount = t("[data-cart-item-count]"),
//         t(document).on("click", "[data-inline-cart-toggle]", function(t) {
//             e.toggle()
//         }),
//         t(document).on("cart.requestComplete", function(t, o) {
//             e.update()
//         }),
//         t(document).on("click", "[data-cart-remove]", function(o) {
//             var n = t(o.currentTarget)
//               , i = n.closest("[data-line-item]")
//               , a = n.attr("data-variant-id");
//             e.removeItem(a),
//             i.remove()
//         }),
//         t(document).on("focusin", "[data-line-item-quantity]", function() {
//             t(this).data("val", t(this).val())
//         }),
//         t(document).on("change", "[data-line-item-quantity]", function() {
//             t(this).data("val");
//             var e = t(this).val()
//               , o = (t(event.currentTarget),
//             t(this).closest(".line-item").attr("data-line-number"));
//             CartJS.cart.total_price,
//             CartJS.updateItem(o, e)
//         }),
//         t(document).on("click", "[data-inline-cart-gift-note-toggle]", function(e) {
//             t(".js-inline-cart-gift-note-container").toggleClass("show-inline-cart-gift-note-container")
//         }),
//         t(document).on("click", "[data-checkout-btn]", function(e) {
//             e.preventDefault(),
//             console.log("click");
//             var o = t('[name="note"]').val() || !1;
//             console.log("note:", o),
//             o ? CartJS.setNote(o, {
//                 success: function(e, t, o) {
//                     window.location = "/checkout"
//                 }
//             }) : window.location = "/checkout"
//         }),
//         e.update()
//     }
// }(window.InlineCart = window.InlineCart || {}, jQuery),
function(e, t) {
    e.init = function() {
        new e
    }
}(window.LazyLoad = window.LazyLoad || {}, jQuery);
var _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
    return typeof e
}
: function(e) {
    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
}
;
!function(e, t) {
    "use strict";
    var o = {}
      , n = function() {
        "object" === ("undefined" == typeof theme ? "undefined" : _typeof(theme)) && "function" == typeof theme.matchHeight && setTimeout(function() {
            theme.matchHeight()
        }, 1)
    };
    e.init = function() {
        o.matchHeight = t(".js-match-height"),
        o.matchHeight.on("click", n)
    }
}(window.MatchHeight = window.MatchHeight || {}, jQuery),
function(e, t) {
    var o = {};
    e.show = function() {
        o.mobileNavToggle.addClass("is-active"),
        o.mobileNav.addClass("is-active"),
        Scroll.lock(),
        Overlay.show()
    }
    ,
    e.hide = function() {
        o.mobileNavToggle.removeClass("is-active"),
        o.mobileNav.removeClass("is-active"),
        Scroll.unlock(),
        Overlay.hide()
    }
    ;
    e.init = function() {
        o.mobileNavToggle = t("[data-mobile-nav-toggle]"),
        o.mobileNav = t("[data-mobile-nav]"),
        o.navLink = t("[data-nav-link]"),
        o.navLink.on("click", function(e) {
            window.dataLayer = window.dataLayer || [];
            var o = t(e.currentTarget)
              , n = o.attr("data-parent-item")
              , i = o.attr("data-nav-link")
              , a = "";
            a = n ? n + ", " + n + " > " + i : i,
            console.log(a),
            window.dataLayer.push({
                event: "Nav Click",
                navItem: a
            }),
            e.stopPropagation()
        }),
        o.mobileNavToggle.on("click", function(o) {
            t(o.currentTarget).hasClass("is-active") ? e.hide() : e.show()
        }),
        t("[data-open-subnav]").on("click", function(e) {
            e.preventDefault(),
            t(e.currentTarget).next("[data-subnav]").addClass("is-active")
        }),
        t("[data-close-subnav]").on("click", function(e) {
            e.preventDefault(),
            t(e.currentTarget).closest("[data-subnav]").removeClass("is-active")
        })
    }
}(window.MobileNav = window.MobileNav || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {};
    e.show = function(e) {
        return window.Overlay.show(),
        window.Scroll.lock(),
        o.body.attr("data-active-modal", e),
        t('[data-modal="' + e + '"]').fadeIn(300)
    }
    ,
    e.hide = function() {
        return window.Overlay.hide(),
        window.Scroll.unlock(),
        o.body.removeAttr("data-active-modal"),
        o.modal.fadeOut(300)
    }
    ;
    e.init = function() {
        o.body = t("body"),
        o.modal = t("[data-modal]"),
        o.modalShow = t("[data-modal-show]"),
        o.modalHide = t("[data-modal-hide]"),
        o.modalShow.on("click", function(e) {
            e.preventDefault(),
            window.Modal.show(t(this).attr("data-modal-show"))
        }),
        o.modalHide.on("click", function(e) {
            e.preventDefault(),
            window.Modal.hide()
        })
    }
}(window.Modal = window.Modal || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {}
      , n = function(e) {
        var t = e.find(".email").val();
        return !!t.length && t
    }
      , i = function(e, t) {
        var o = e.find(".js-newsletter-response");
        switch (t) {
        case "subscribe":
            o.html("Thank you for signing up!");
            break;
        case "success":
            o.html("Thank you for signing up!");
            break;
        case "error":
            o.html("We're sorry. Something went wrong, please try again.")
        }
    }
      , a = function(e) {
        e.preventDefault();
        var o = t(e.currentTarget);
        i(o, "subscribe");
        var a, r = n(o), s = !!(a = o.find('[name="SKINTYPE"]:checked').map(function(e, t) {
            return t.value
        }).get().join(", ")).length && a;
        if (r) {
            var l = {
                email: r,
                lists: {
                    "Subscribed 5718": 1
                },
                vars: {},
                onSuccess: function() {
                    i(o, "success")
                },
                onError: function() {
                    i(o, "error")
                }
            };
            s && (l.vars["SkinSignUp"] = s)
        } else
            i(o, "error")
    };
    e.init = function() {
        o.newsletter = t(".js-newsletter"),
        o.newsletter.on("submit", a)
    }
    ,
    e.submitPdfForm = function(e) {
        e.preventDefault();
        var o = t(e.currentTarget);
        i(o, "subscribe");
        var a = n(o);
        if (a) {
            var r = {
                email: a,
                lists: {
                    "Subscribed 5718": 1
                },
                vars: {},
                onSuccess: function() {
                    t(".downloadPdf-modal").removeClass("showModal"),
                    t(".modalbackground").removeClass("showModal"),
                    window.location.href = "https://cdn.shopify.com/s/files/1/0249/1218/files/Soko_Glam_10-Step_Skincare_Routine.pdf?4470562713874017923",
                    i(o, "success")
                },
                onError: function() {
                    i(o, "error")
                }
            };
        } else
            i(o, "error")
    }
}(window.Newsletter = window.Newsletter || {}, jQuery),
function(e, t) {
    var o = window.productJson || {}
      , n = function(t, o) {
        e.updateATC({
            variant: t,
            selector: o
        })
    };
    e.updateATC = function(e) {
        var o = e.variant
          , n = (e.selector,
        t("[data-add-to-cart]"))
          , i = t("#ProductPrice")
          , a = t("#ComparePrice")
          , r = (t(".product-qty"),
        t("#AddToCartText"));
        $pdpWishlist = t(".pdp-atc-form__wishlist"),
        $pdpQtyContainer = t(".pdp-atc-form__qty"),
        o && (n.attr("data-variant-id", o.id),
        n.attr("data-add-to-cart", ""),
        o.available ? (n.removeClass("pdp-sold-out-btn").removeAttr("id", "BIS_trigger_Listrak"),
        r.html("ADD TO BAG"),
        $pdpWishlist.show(),
        $pdpQtyContainer.show(),
        t("#main-product-detail .ProductPrice, #quickshop .ProductPrice").text(Shopify.formatMoney(o.price))) : (n.addClass("pdp-sold-out-btn").attr("id", "BIS_trigger_Listrak").removeAttr("data-add-to-cart"),
        r.html("EMAIL ME WHEN IN STOCK"),
        $pdpWishlist.hide(),
        $pdpQtyContainer.hide(),
        t(".quickshop-inner .add-to-cart-btn-text").html("This product is unavailable")),
        i.html(Shopify.formatMoney(o.price)),
        o.compare_at_price > o.price ? a.html(Shopify.formatMoney(o.compare_at_price, moneyFormat)).show() : a.hide())
    }
    ,
    e.dummySelect = function() {
        $selectWrap = t("[data-cart-submit] .selector-wrapper"),
        $selectWrap.each(function() {
            var e = t(this)
              , o = e.find("label")
              , n = e.find("select")
              , i = o.text().toLowerCase()
              , a = e.find("option:selected")
              , r = n.find("option")
              , s = t('<ul class="dummy-select option-' + i + '"></ul>')
              , l = o.length > 0 ? o.text() : a.text()
              , c = t('<div class="selection">' + l + "</div>");
            setTimeout(function() {
                r.each(function(e, o) {
                    var n, a = t(o);
                    n = a.hasClass("disabled") ? "disabled" : "",
                    s.append('<li class="' + n + '" val="' + a.attr("value") + '" data-dummy-index="' + e + '"><span class="' + i + "-" + Shopify.handleize(a.attr("value")) + '"></span>' + a.text() + "</li>")
                }),
                e.prepend(s),
                e.prepend(c),
                o.add(n).hide()
            }, 0),
            $selectWrap.on("click", "li", function() {
                var o = (e = t(this)).attr("val")
                  , i = e.text();
                c.text(i).removeClass("show"),
                s.stop().slideUp(250),
                n.val(o).trigger("change"),
                t(".note", ".submit-row").hide(),
                color_len = s.find("li").length,
                img_len = t(".thumbnails").find("li").not(".slick-cloned").length,
                img_len_mobile = t(".thumbnails").find(".slick-slide").not(".slick-cloned").length,
                img_offset = img_len - color_len,
                img_offset_mobile = img_len_mobile - color_len,
                index = e.index() + img_offset,
                index_mobile = e.index() + img_offset_mobile,
                t(".thumbnail").eq(index).click(),
                t(".thumbnails").slick("slickGoTo", index_mobile)
            }),
            c.click(function() {
                (e = t(this)).toggleClass("show"),
                s.stop().slideToggle(250)
            })
        })
    }
    ,
    e.modifyFormView = function() {
        o = window.productJson || {},
        t('[data-product-options="Title"]').hide();
        var e = o.variants[0].title
          , n = o.options[0]
          , i = o.options.length;
        1 == o.options.length && "Title" != o.options[0] && t(".selector-wrapper:eq(0)").prepend('<label for="productSelect-option-0">' + n + "</label>"),
        -1 !== e.indexOf("Default Title") ? (t(".selector-wrapper:eq(0)").hide(),
        t(".product-form").addClass("options-0")) : t(".product-form").addClass("options-" + i),
        t.each(o.variants, function(e, n) {
            1 === o.options.length && !n.available && t(".selector-wrapper:eq(0) option:eq(" + e + ")").attr("disabled", "disabled").addClass("disabled")
        })
    }
    ,
    e.init = function() {
        new Shopify.OptionSelectors("productSelect",{
            product: window.productJson,
            onVariantSelected: n,
            enableHistoryState: !1
        }),
        e.modifyFormView()
    }
}(window.OptionSelection = window.OptionSelection || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {};
    e.show = function() {
        return o.overlay.fadeIn(300)
    }
    ,
    e.hide = function() {
        return o.overlay.fadeOut(300)
    }
    ,
    e.toggle = function() {
        return o.overlay.fadeToggle(300)
    }
    ;
    e.init = function() {
        o.overlay = t("[data-overlay]"),
        o.overlay.on("click", window.Overlay.hide),
        o.overlay.on("click", window.Modal.hide),
//         o.overlay.on("click", window.Quickshop.hide),
//         o.overlay.on("click", window.InlineCart.hide),
        o.overlay.on("click", window.MobileNav.hide),
        o.overlay.on("click", window.Filter.hide),
        t(".js-close-pdp-modal").on("click", window.Overlay.hide),
        t(".js-close-pdp-modal").on("click", window.Modal.hide)
    };
  e.init();
}(window.Overlay = window.Overlay || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {};
    e.init = function() {
        o.qtyControl = t("[qty-control]"),
        o.qtyInput = t("[qty-input]"),
        o.descriptionFull = t(".tab-content--full"),
        o.descriptionShort = t(".tab-content--short"),
        o.tabShowMore = t("[data-show-more]"),
        o.tabShowLess = t("[data-show-less]"),
        o.tabShowMore.on("click", function(e) {
            e.preventDefault();
            var n = t(e.currentTarget).closest(".pdp-tab-content")
              , i = n.find(o.descriptionFull)
              , a = n.find(o.descriptionShort);
            i.show(),
            a.hide()
        }),
        o.tabShowLess.on("click", function(e) {
            e.preventDefault();
            var n = t(e.currentTarget).closest(".pdp-tab-content")
              , i = n.find(o.descriptionFull)
              , a = n.find(o.descriptionShort);
            i.hide(),
            a.show()
        })
    }
}(window.Product = window.Product || {}, jQuery),
function(e, t) {
    e.init = function() {
        t(".js-routine-steps-container").find(".js-routine-link-1").on("mouseenter", function() {
            t(".js-routine-steps-container").addClass("step-3-bottle-active")
        }),
        t(".js-routine-steps-container").find(".js-routine-link-1").on("mouseleave", function() {
            t(".js-routine-steps-container").removeClass("step-3-bottle-active")
        }),
        t(".js-routine-steps-container").find(".js-routine-link-2").on("mouseenter", function() {
            t(".js-routine-steps-container").addClass("step-5-bottle-active")
        }),
        t(".js-routine-steps-container").find(".js-routine-link-2").on("mouseleave", function() {
            t(".js-routine-steps-container").removeClass("step-5-bottle-active")
        }),
        t(".js-routine-steps-container").find(".js-routine-link-3").on("mouseenter", function() {
            t(".js-routine-steps-container").addClass("step-10-bottle-active")
        }),
        t(".js-routine-steps-container").find(".js-routine-link-3").on("mouseleave", function() {
            t(".js-routine-steps-container").removeClass("step-10-bottle-active")
        })
    }
}(window.RoutineStepsSection = window.RoutineStepsSection || {}, jQuery),
function(e, t) {
    "use strict";
    e.lock = function(e) {
        t("html, body").addClass("no-scroll")
    }
    ,
    e.unlock = function(e) {
        t("html, body").removeClass("no-scroll")
    }
    ,
    e.toggle = function(e) {
        t("html, body").toggleClass("no-scroll")
    }
    ;
    e.init = function() {}
}(window.Scroll = window.Scroll || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {};
    e.checkString = function(e) {
        var t = e.toLowerCase().split(" ").join("");
        window.location.href = "son&park" == t ? "/search?type=product&q=" + encodeURIComponent("Son & Park").replace(/%20/g, "%2B") : "/search?type=product&q=" + e.split(" ").join("+")
    }
    ,
    e.toggleBar = function() {
        o.searchTrigger.toggleClass("active"),
        o.searchOverlay.toggleClass("is-active"),
        o.cartFlyout.hide(),
        o.cartTrigger.removeClass("active")
    }
    ;
    var n = function(e) {
        if (e > 991) {
            var t = document.querySelector(".snize-ac-results");
            t && "none" != t.style.display ? document.body.classList.contains("noscroll") || document.body.classList.add("noscroll") : document.body.classList.remove("noscroll")
        } else {
            document.querySelector(".header-search__search-overlay").classList.contains("is-active") ? document.body.classList.add("noscroll") : document.body.classList.remove("noscroll")
        }
    };
    e.init = function() {
        o.searchForm = t("#header-search form"),
        o.searchTrigger = t(".menu__search"),
        o.headerSearchTrigger = t(".global-header .menu__search"),
        o.searchForm = t("#header-search"),
        o.searchInput = t(".header-search__input"),
        o.searchOverlay = t(".header-search__search-overlay"),
        o.searchClear = t(".header-search__clear-icon"),
        o.cartFlyout = t("#cart-flyout"),
        o.cartTrigger = t(".menu__cart"),
        o.mobileMenuSearchIcon = t(".mobile-nav__header-item.menu__search"),
        t(window).on("mousemove", function() {
            n(window.innerWidth)
        }),
        t(window).on("touchstart", function() {
            n(window.innerWidth)
        }),
        o.searchForm.submit(function(t) {
            t.preventDefault();
            var n = o.searchForm.serializeArray()[1].value;
            e.checkString(n)
        }),
        o.searchTrigger.click(function(t) {
            e.toggleBar(),
            o.searchInput.focus()
        }),
        o.searchClear.click(function(t) {
            "" !== o.searchInput.val() ? (o.searchInput.val(""),
            o.searchInput.focus()) : e.toggleBar()
        }),
        o.mobileMenuSearchIcon.hide()
    }
}(window.Search = window.Search || {}, jQuery),
// function(e, t) {
//     e.init = function() {
//         t(".js-shop-by-tab-content-container").find(".js-shop-by-heading-container").on("click", function() {
//             t(this).toggleClass("is-active").next().slideToggle(),
//             t(this).toggleClass("opened")
//         }),
//         t(document).ready(function() {
//             t(".shop-tab-title:first-child").addClass("is-active-title"),
//             t(".js-shop-by-tab-content-container:nth-child(1)").show(),
//             t(".js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(4)").hide()
//         }),
//         t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(1)").on("click", function() {
//             t(this).toggleClass("is-active-title"),
//             t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(1)").show(),
//             t(".shop-tab-title:nth-child(3), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
//             t(".js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(4)").hide(),
//             t(".js-shop-by-tab-tiles-container").slick("setPosition"))
//         }),
//         t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(2)").on("click", function() {
//             t(this).toggleClass("is-active-title"),
//             t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(2)").show(),
//             t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(3), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
//             t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(3), .js-shop-by-tab-content-container:nth-child(4)").hide(),
//             t(".js-shop-by-tab-tiles-container").slick("setPosition"))
//         }),
//         t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(3)").on("click", function() {
//             t(this).toggleClass("is-active-title"),
//             t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(3)").show(),
//             t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(4)").removeClass("is-active-title"),
//             t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(4)").hide(),
//             t(".js-shop-by-tab-tiles-container").slick("setPosition"))
//         }),
//         t(".js-shop-by-main-tab-container").find(".shop-tab-title:nth-child(4)").on("click", function() {
//             t(this).toggleClass("is-active-title"),
//             t(this).hasClass("is-active-title") && (t(".js-shop-by-tab-content-container:nth-child(4)").show(),
//             t(".shop-tab-title:nth-child(1), .shop-tab-title:nth-child(2), .shop-tab-title:nth-child(3)").removeClass("is-active-title"),
//             t(".js-shop-by-tab-content-container:nth-child(1), .js-shop-by-tab-content-container:nth-child(2), .js-shop-by-tab-content-container:nth-child(3)").hide(),
//             t(".js-shop-by-tab-tiles-container").slick("setPosition"))
//         })
//     }
// }(window.ShopBySection = window.ShopBySection || {}, jQuery),
// function(e, t) {
//     var o = {}
//       , n = window.innerWidth <= 782
//       , i = {
//         slidesToShow: 1,
//         arrows: !1,
//         dots: !0,
//         autoplay: !0,
//         autoplaySpeed: 8e3,
//         pauseOnHover: !1,
//         responsive: [{
//             breakpoint: 783,
//             settings: {
//                 dots: !1
//             }
//         }]
//     }
//       , a = {
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         arrows: !0,
//         dots: !1,
//         infinite: !1,
//         responsive: [{
//             breakpoint: 783,
//             settings: "unslick"
//         }]
//     }
//       , r = {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         fade: !1,
//         arrows: !0,
//         autoplay: !0,
//         autoplaySpeed: 6e3,
//         asNavFor: ".js-press-logo-slider-container",
//         responsive: [{
//             breakpoint: 783,
//             settings: {
//                 arrows: !1,
//                 dots: !1
//             }
//         }]
//     }
//       , s = {
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         asNavFor: ".js-press-quote-slider-container",
//         dots: !1,
//         arrows: !1,
//         focusOnSelect: !0,
//         responsive: [{
//             breakpoint: 783,
//             settings: {
//                 slidesToShow: 1,
//                 dots: !0
//             }
//         }]
//     }
//       , l = {
//         slidesToShow: 1,
//         dots: !1,
//         arrows: !1,
//         adaptiveHeight: !0
//     }
//       , c = {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         dots: !0,
//         arrows: !0,
//         infinite: !1,
//         asNavFor: ".pdp-thumbnail__aside",
//         responsive: [{
//             breakpoint: 768,
//             settings: {
//                 adaptiveHeight: !0
//             }
//         }]
//     }
//       , d = {
//         slidesToShow: 17,
//         slidesToScroll: 1,
//         dots: !1,
//         arrows: !0,
//         asNavFor: "[pdp-main-slider]",
//         focusOnSelect: !0
//     }
//       , u = {
//         slidesToShow: 4,
//         slidesToScroll: 1,
//         arrows: !0,
//         dots: !1,
//         infinite: !0,
//         responsive: [{
//             breakpoint: 1024,
//             settings: {
//                 slidesToShow: 2
//             }
//         }]
//     }
//       , f = function() {
//         o.homeShopBySlider.slick(a)
//     };
//     e.init = function() {
//         t(window).on("load resize orientationchange", function() {
//             t(".js-promo-tile-grid-container, .js-the-klog-articles-container").each(function() {
//                 var e = t(this);
//                 t(window).width() >= 783 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
//                     slidesToShow: 1,
//                     slidesToScroll: 1,
//                     mobileFirst: !0,
//                     arrows: !0,
//                     dots: !0
//                 })
//             })
//         }),
//         t(window).on("load resize orientationchange", function() {
//             t(".js-account--nav__control-bar-inner-orders").each(function() {
//                 var e = t(this);
//                 t(window).width() >= 992 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
//                     infinite: !1,
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     mobileFirst: !0,
//                     arrows: !0,
//                     dots: !1
//                 })
//             })
//         }),
//         t(window).on("load resize orientationchange", function() {
//             t(".js-account--nav__control-bar-inner-info").each(function() {
//                 var e = t(this);
//                 t(window).width() >= 992 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
//                     infinite: !1,
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     mobileFirst: !0,
//                     arrows: !0,
//                     dots: !1,
//                     initialSlide: 1
//                 })
//             })
//         }),
//         t(window).on("load resize orientationchange", function() {
//             t(".js-account--nav__control-bar-inner-addresses").each(function() {
//                 var e = t(this);
//                 t(window).width() >= 992 ? e.hasClass("slick-initialized") && e.slick("unslick") : e.hasClass("slick-initialized") || e.slick({
//                     infinite: !1,
//                     slidesToShow: 2,
//                     slidesToScroll: 1,
//                     mobileFirst: !0,
//                     arrows: !0,
//                     dots: !1,
//                     initialSlide: 2
//                 })
//             })
//         }),
//         t(window).on("resize", function(e) {
//             window.innerWidth > 782 ? n && (f(),
//             n = !1) : n || (n = !0)
//         }),
//         o.homeHeroSlider = t(".js-homepage-slider-container"),
//         o.homeShopBySlider = t(".js-shop-by-tab-tiles-container"),
//         o.homePressQuoteSlider = t(".js-press-quote-slider-container"),
//         o.homePressLogoSlider = t(".js-press-logo-slider-container"),
//         o.tenStepLandingPageSlider = t(".slides__container"),
//         o.pdpMainSlider = t("[pdp-main-slider]"),
//         o.pdpThumbnailSlider = t(".pdp-thumbnail__aside"),
//         o.pdpRelatedProductsSlider = t("[pdp-related-products-slider]"),
//         o.homeHeroSlider.slick(i),
//         o.homeShopBySlider.slick(a),
//         o.homePressQuoteSlider.slick(r),
//         o.homePressLogoSlider.slick(s),
//         o.tenStepLandingPageSlider.slick(l),
//         o.pdpMainSlider.slick(c),
//         o.pdpThumbnailSlider.slick(d),
//         o.pdpRelatedProductsSlider.slick(u)
//     }
// }(window.Sliders = window.Sliders || {}, jQuery),
function(e, t) {
    e.init = function() {
        t(".smoothScroll").click(function() {
            var e = t(this).data("scroll-to")
              , o = t('[data-scroll-target="' + e + '"]');
            console.log(e),
            console.log(o),
            t("html, body").animate({
                scrollTop: o.offset().top + -80
            }, 600)
        }),
        t(".js-hero-view-more-icon-container").click(function() {
            t("html, body").animate({
                scrollTop: t(".js-shop-carousel-container").offset().top + -80
            }, 600)
        })
    }
}(window.SmoothScroll = window.SmoothScroll || {}, jQuery),
function(e, t) {
    "use strict";
    var o = {}
      , n = function(e) {
        var o = t(e.currentTarget)
          , n = o.attr("data-index");
        t(".slides__container").slick("slickGoTo", n),
          console.log('slide num',n),
        a(768),
        o.css("background-color", stepBtnBg),
        t(window).width() < 992 && o.css("border-right", "2px solid #EC138D")
    };
    function i(e) {
        var o = function(e) {
            var o = t('<span class="tempforSize">' + e + "</span>").prependTo("body")
              , n = o.width();
            return o.remove(),
            n
        }(e.children(":selected").html())
          , n = e.width() - o;
        e.css("text-indent", n / 2 - 10)
    }
    var a = function(e) {
        t(".selector__item").each(function(o, n) {
            t(n).css("background-color", "white"),
            t(n).css("border-right", "none"),
            t(window).width() <= e ? (t(".slides__container").css("display", "block"),
            t(n).find(".selector__icon").css("display", "none"),
            t(n).find(".selector__title").css("display", "none"),
            t(".slides__container").css("flex", "1"),
            t(".selector__back").css("display", "flex"),
            t(".selector__backbtn").css("display", "block"),
            t(".selector").css("width", "auto"),
            t(".vertical__box").each(function(e, o) {
                return t(o).css("display", "none")
            })) : (t(n).find(".selector__icon").css("display", "block"),
            t(n).find(".selector__title").css("display", "block"))
        })
    }
      , r = function(e) {
        e.preventDefault();
        var t = e.currentTarget.previousElementSibling
          , o = e.currentTarget;
        t.classList.toggle("toggle-height"),
        "READ MORE" === o.innerText ? o.innerText = "READ LESS" : o.innerText = "READ MORE"
    }
      , s = function(e) {
        e.preventDefault();
        var o = t(e.currentTarget).parent().next();
        "none" == o.css("display") ? (o.slideDown(),
        t(".routine__down-arrow").text("-")) : (t(".routine__down-arrow").text("+"),
        o.slideUp())
    }

      , d = function(e) {
        e.preventDefault(),
        "block" === t(e.currentTarget).css("display") && (t(e.currentTarget).css("display", "none"),
        t(".selector__back").css("display", "none"),
        t(".selector__item").each(function(e, o) {
            t(o).find(".selector__icon").css("display", "block"),
            t(o).find(".selector__title").css("display", "block"),
            t(".slides__container").css("flex", "none"),
            t(".slides__container").css("display", "none"),
            t(".selector").css("width", "100%"),
            t(".vertical__box").each(function(e, o) {
                t(o).css("display", "block")
            })
        }))
    };
    t(".slides__container").on("afterChange", function(e, o, n) {
        a(768),
        t(t(".selector__item")[n]).css("background-color", stepBtnBg),
        t(window).width() < 992 && t(t(".selector__item")[n]).css("border-right", "2px solid #EC138D")
    }),
    t(".step__next-btn").on("click", function(e) {
        e.preventDefault();
        var o = t(e.currentTarget).parent().index();
        t(".slides__container").slick("slickGoTo", o),
        a(768),
        t(t(".selector__item")[o]).css("background-color", stepBtnBg),
        t(window).width() < 992 && t(t(".selector__item")[o]).css("border-right", "2px solid #EC138D")
    }),
    t(".routine__btn").on("click", function(e) {
        e.preventDefault(),
        t(".skintype-modal").addClass("showModal"),
        t(".modalbackground").addClass("showModal")
    }),
    t(".skintype-modal__exit, .skintype-modal__btn").on("click", function(e) {
        e.preventDefault(),
        t(".skintype-modal").removeClass("showModal"),
        t(".modalbackground").removeClass("showModal")
    });
    e.init = function() {
      console.log('is initialized'),
        o.selectorItem = t(".selector__item"),
        o.stepNext = t(".step__next-btn"),
        o.readMoreBtn = t("[data-read-more-btn]"),
        o.selectorItem.click(n),
        o.readMoreBtn.on("click", r),
        t(".routine__down-arrow").on("click", s),
        t(".selector__backbtn").on("click", d),
        t(window).resize(function() {
            t(window).width() < 992 || t(".routine__list").slideDown()
        })
    };
  e.init();
}(window.TenStepLandingPage = window.TenStepLandingPage || {}, jQuery),
function(e, t) {
    var o = t(".venobox").venobox();
    e.init = function() {
        t(".venobox").venobox(),
        t(document).on("click", ".closeme", function(e) {
            o.VBclose()
        })
    }
}(window.VenoboxModals = window.VenoboxModals || {}, jQuery),
function(e, t) {
  t(".hover-link").hover(function(){
    let g = t(this).find('> g');
    t(g).addClass('active');
    t(`.img__info[data-info="${t(g).attr('id')}"]`).css('display','block');
  },function(){
    let g = t(this).find('> g');
    t(g).removeClass('active');
    t(`.img__info[data-info="${t(g).attr('id')}"]`).css('display','none');
  });
}(window.onSvgHoverShowInfo = window.onSvgHoverShowInfo || {}, jQuery);

!function(e, t){
  var sf = t('.bc-sf-search-box'),
      ss = t('.bc-sf-search-suggestion'),
      sc = t('.bc-sf-search-suggestion-wrapper'),
      q = "",
      hideContainer = function(){
        t(sc).css('display','none');
      },
      showContainer = function(){
        t(sc).css('display','block');
      },
      search = async function(q){
        let response = await fetch(`/search/suggest.json?q=${q}&resources[type]=product,collection,page&resources[options][unavailable_products]=show`);
        let result = await response.json();
       // console.log('Results...', result);
        return result.resources.results;
      },
      setDropdown = function(){
        let promo_bar_h = $('.persistent-banner').height();
        let main_nav_wrapper_h = $('.desktop-header').height();
        let mob_nav_wrapper_h = $(".bc-sf-search-suggestion-mobile-top-panel form").height();
        console.log(promo_bar_h,main_nav_wrapper_h);
//         let dropdown_top = promo_bar_h  + main_nav_wrapper_h;
        let dropdown_top = 56;
        if(t(window).width() <= 767){
          t('.bc-sf-search-suggestion-wrapper').addClass('bc-sf-search-suggestion-mobile');
          t('.bc-sf-search-suggestion-wrapper').css('top',`${mob_nav_wrapper_h}px`);
        }else{
          t('.bc-sf-search-suggestion-wrapper').css('top',`${dropdown_top}px`);
        }
      	t(window).resize(function() {
          if(t(window).width() >= 768){
            t('.bc-sf-search-suggestion-wrapper').removeClass('bc-sf-search-suggestion-mobile');
            t('.bc-sf-search-suggestion-wrapper').css('top',`${dropdown_top}px`);
          }else{
            t('.bc-sf-search-suggestion-wrapper').addClass('bc-sf-search-suggestion-mobile');
            t('.bc-sf-search-suggestion-wrapper').css('top',`${mob_nav_wrapper_h}px`);
          }
		});  
      },
//       loadCollections = function(collections){
//         let el = `<li class="ra__search-collection no_style_li" data-group="collections" aria-label="Collections">
//          			<ul aria-hidden="true" aria-expanded="false" class="main__search--div" style="display: none;">
//             		  <div class="search__header" aria-label="Collections">Collections</div>
//                        <div class="search__product-list no_style_li">
// ${collections.map((collection,i)=> {
//   if(i>=3) return;
//                           return `<div class="search_product-item" aria-label="${collection.title}">
// 						    <a href="${collection.url}" id="ui-id-117" tabindex="-1" class="ui-menu-item-wrapper">${collection.title}</a>
// 					  	  </div>
// 						`;}).join('')}
//          			</div>
//                    </ul>
//       			  </li>`;
//         t(ss).append(el);

//       },
      loadProducts = function(products){
        let el = `<li class="ra__search-collection no_style_li product-1" data-group="products" aria-label="Products">
         			<ul aria-hidden="true" aria-expanded="false" class="main__search--div product__search" style="display: none;">
            		  <div class="search__header" aria-label="Products">Products</div>
                        <div class="search__product-list no_style_li">
			${products.map((product,i)=>{
  			  if(i>=3) return;	
              return `
            		  <div class="search_product-item" aria-label="Products: ${product.title}">
               			<a href="${product.url}" id="ui-id-120" tabindex="-1" class="ser_pro-link">
                  		<div class="ser_pro-img">
						  <img src="${product.image}" alt="${product.title}" loading="lazy"/>
						</div>
                  		<div class="ser_pro-right">
                     	  <div class="ser_pro-title">${product.title}</div>
                     	  ${product.sku ? `<div class="ser_pro-sku">SKU: ${product.sku}</div>` : ''}
						  ${product.vendor ? `<div class="ser_pro-vendor">${product.vendor}</div>` : ''}
                     	  <div class="ser_pro-price"><span class="ser_pro-price-inner">
							<span class="ser_pro_money">${theme.Currency.formatMoney(product.price, theme.moneyFormat)}</span>
						  </div>
                  		</div>
               			</a>
            		  </div>
			`;}).join('')}
                      </div>
         			</ul>
               </li>`;
        t(ss).append(el);
      },
       loadCollections = function(collections){
        let el = `<li class="ra__search-collection no_style_li collection-1" data-group="collections" aria-label="Collections">
         			<ul aria-hidden="true" aria-expanded="false" class="main__search--div" style="display: none;">
            		  <div class="search__header collection-header" aria-label="Collections">Collections</div>
                       <div class="search__product-list no_style_li">
${collections.map((collection,i)=> {
  if(i>=3) return;
                          return `<div class="search_product-item" aria-label="${collection.title}">
						    <a href="${collection.url}" id="ui-id-117" tabindex="-1" class="ui-menu-item-wrapper">${collection.title}</a>
					  	  </div>
						`;}).join('')}
         			</div>
                   </ul>
      			  </li>`;
        t(ss).append(el);

      },
      loadPages = function(pages){
        let el = `<li class="ra__search-collection no_style_li pages-1" data-group="pages" aria-label="Pages">
         			<ul aria-hidden="true" aria-expanded="false" class="main__search--div" style="display: none;">
            		  <div class="search__header pages__main" aria-label="Pages">Pages</div>
                         <div class="search__product-list no_style_li">
					  ${pages.map(page=>`
            		  <div class="search_product-item" aria-label="Pages: ${page.title}">
                        <a href="${page.url}" tabindex="-1" class="page__inner-link">${page.title}</a>
                       </div>
					  `).join('')}
                      </div>
         			</ul>
      			  </li>`;
        t(ss).append(el);
      },
      loadViewAll = function(){
      	let el = `
			  <li class="view_all-button-end view-1" aria-label="View All">
				<a href="/search?options%5Bprefix%5D=last&q=${q}" tabindex="-1" class="view_all-btn-link">View all products with "${q}"</a>
			  </li>
			`;
        t(ss).append(el);
      },
      loadNoResult = function(){
        let el = `<li class="bc-sf-search-suggestion-no-result ui-menu-item" aria-label="No Results">
					<span id="ui-id-29" tabindex="-1" class="ui-menu-item-wrapper">Sorry, nothing found for "${q}"</span>
				  </li>`;
        t(ss).append(el);
      },
      changeHandlers = function(){
        t(sf).focusin(function(){
          if(t(this).val().length >= 2){
            showContainer();
          }
        });
        t(sf).focusout(function(){
          setTimeout(function(){
            hideContainer();
          },300);
        });
        t(sf).keyup(async function(e){
          q = t(this).val();
          if(q.length >= 2){
            showContainer();
            let {products,collections,pages} = await search(q);
            console.log(products,collections,pages);
            t(ss).empty();
            if(collections.length === 0 && products.length === 0 && pages.length === 0){
              loadNoResult();
            }else{
              collections.length !== 0 && loadCollections(collections);
              products.length !== 0 && loadProducts(products);
              pages.length !== 0 && loadPages(pages);
              if(products.length > 3){
                loadViewAll();
              }
            }
          }
          
        });
        t('.icon-search.dropdown_link').click(function(e){
          e.preventDefault();
          t('.bc-sf-search-suggestion-mobile-top-panel').css('display','block');
        });
        t('.bc-sf-search-btn-close-suggestion').click(function(e){
          t('.bc-sf-search-suggestion-mobile-top-panel').css('display','none');
          hideContainer();
        });
      };
      e.init = function(){
      	changeHandlers();
        setDropdown();
      };
}(window.PredictiveSearch = window.PredictiveSearch || {}, jQuery),
 function(e, t){
  t(document).ready(function(){
    Header.init();
  	SmoothScroll.init();
    VenoboxModals.init();
	Accordion.init();
    PredictiveSearch.init();
  });
}(window.Initialize = window.Initialize || {}, jQuery);}